import React, { useState, useEffect, useRef } from "react";
import "./Css/Project.css";
import "./Css/Project-responsive.css";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../Controllers/Store";

import { Ripple } from "primereact/ripple";
import { Dialog } from "primereact/dialog";
import { Dropdown, DropdownChangeEvent, DropdownProps } from "primereact/dropdown";
import { Skeleton } from "primereact/skeleton";
import { Image } from "primereact/image";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { DataTable, DataTableSelectionMultipleChangeEvent } from "primereact/datatable";
import { Column } from "primereact/column";
import { OverlayPanel } from "primereact/overlaypanel";
import { Message } from 'primereact/message';
import { InputText } from "primereact/inputtext";
import { Tooltip } from "primereact/tooltip";

import { Swiper, SwiperSlide } from 'swiper/react';
import { Swiper as SwiperType } from 'swiper'
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

import ProjectModal from "./ProjectModal";
import ErrorPage from "../../Components/ErrorPage";
import PageLoader from "../../Components/PageLoader";
import InfoModal from "../../Components/InfoModal";
import { goToTop } from "../../Components/goToTop";
import { getAppCurrencyType } from "../../Utils/Common";

import { useAppDispatch, useAppSelector } from "../../Controllers/hooks";
import {
  fetchAllContact,
  fetchAllProjects,
  fetchAllUserRole,
  getSharedFoldersData,
} from "../../Controllers/Thunks/projectThunks";
import { Project, ProjectBasicContact, SubscriptionDetails } from "../../Controllers/Types/Project/ProjectInterface";
import { ProjectContact } from "../../Controllers/Types/Project/ProjectContact";
import {
  selectAddProjectContact,
  setCheckedProjectContactForAssign,
  setContactSearchKey,
  setSelectedProjectBasicContact,
  setSelectedProjectDetails,
  setSelectedUserRole,
  setSelectedUserType,
} from "../../Controllers/Slices/projectSlice";
import { getNonNullValue } from "../../Utils/Validator";
import { moveFolder, projectLicenseUpdateAPI, projectShareContact, subscriptionDetailsGetAPI } from "../../Api/ProjectApi";
import { Role } from "../../Controllers/Types/UserRoleInterface";
import { mapShareContacts, ShareContact } from "../../Controllers/Types/Project/ShareContactInterface";
import { checkIsBuildingInspector, checkIsClient, checkIsDClient } from "../../Utils/LoginUserRoleName";

import { getPaymentTypes } from "../../Api/CommonApi";
import { PaymentType, mapPaymentTypes } from "../../Controllers/Types/ApiResponse";

import { hasPermission } from "../../Controllers/Selectors/permissionsSelector";
import { SharedFolder } from "../../Controllers/Types/Project/SharedFolder";
import { SharedFolderBy } from "../../Controllers/Types/Project/SharedFolderBy";

import CheckoutForm from "../PaymentGateWay/CheckoutForm";
import { PaymentIntent } from "@stripe/stripe-js";
import { buyLicense, projectRenew } from "../../Api/PaymentGateWay/PaymentGateWayApiService";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import CustomTableLoader from "../../Components/CustomTableLoader";
import { AllProjectAndSharedType, mapAllProjectAndSharedType } from "../../Controllers/Types/Project/AllProjectAndSharedInterface";

interface EmptyProjectElementProps {
  type: 'All' | 'Current' | 'Ongoing' | 'Completed' | 'Folder';
  message: string;
}

const ProjectComponent: React.FC = () => {
  const navigate = useNavigate();
  const op = useRef<OverlayPanel>(null);
  const currencySymbol = getAppCurrencyType();

  const dispatch = useAppDispatch();
  const allProjects = useAppSelector((state) => state.project.allProjects);
  const currentProjects = useAppSelector((state) => state.project.currentProjects);
  const ongoingProjects = useAppSelector((state) => state.project.ongoingProjects);
  const completedProject = useAppSelector((state) => state.project.completedProject);
  const dataLoading = useAppSelector((state) => state.project.loading);
  const error = useAppSelector((state) => state.project.error);
  const [initialProjectDataLoading, setInitialProjectDataLoading] = useState<boolean>(true);
  const [initialFolderDataLoading, setInitialFolderDataLoading] = useState<boolean>(true);

  const projectAllContact = useAppSelector((state) => state.project.projectAllContact);
  const projectContacts = useAppSelector((state) => state.project.projectContacts);
  const projectContactsFiltered = useAppSelector((state) => state.project.projectContactsFiltered);
  const selectedProjectBasicContact = useAppSelector((state) => state.project.selectedProjectBasicContact);
  const loadingContact = useAppSelector((state) => state.project.loadingContact);
  const errorContact = useAppSelector((state) => state.project.errorContact);

  const userType = useAppSelector((state) => state.project.selectedUserType);
  const countAll = useAppSelector((state) => state.project.countAll);
  const countEmployee = useAppSelector((state) => state.project.countEmployee);
  const countProfessional = useAppSelector((state) => state.project.countProfessional);
  const countClient = useAppSelector((state) => state.project.countClient);

  const [activeTab, setActiveTab] = useState<string>("all");
  const [activeCategory, setActiveCategory] = useState<'Others' | 'Building Control'>("Others");
  const toast = useRef<Toast>(null);
  const [showAssignContactModal, setShowAssignContactModal] = useState<boolean>(false);
  const [showViewAssignContactModal, setShowViewAssignContactModal] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [dataViewMode, setDataViewMode] = useState<string>("listViewMode");
  const [projectSearchFilter, setProjectSearchFilter] = useState<string>("");

  const [selectedProject, setSelectedProject] = useState<Project | null>(null);

  const [dataState, setDataState] = useState<"Add" | "Edit" | "Renewal">("Add");
  const [isModalOpen, setModalOpen] = useState(false);
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [successMessage, setSuccessMessage] = useState<string>("");

  const [bodyHeight, setBodyHeight] = useState<number | "auto">("auto");
  const contactListBodyRef = useRef<HTMLDivElement>(null);

  /********************************* Assign contact variables ***********************************/

  //const [checkedContact, setCheckedContact] = useState<boolean>(false);
  /**********************************************************************************************/

  /************************************ For Table view mode *************************************/
  const [selectedAllProjectType, setSelectedAllProjectType] = useState<string | null>(null);
  const [selectedCurrentProjectType, setSelectedCurrentProjectType] = useState<string | null>(null);
  const [selectedOngoingProjectType, setSelectedOngoingProjectType] = useState<string | null>(null);
  const [selectedCompletedProjectType, setSelectedCompletedProjectType] = useState<string | null>(null);
  const [projetTypes] = useState<string[]>(["Commercial", "Domestic"]);
  /**********************************************************************************************/

  /* ******************************* License renewal ******************************* */
  const [showProjectRenewalModal, setShowProjectRenewalModal] = useState<boolean>(false);
  const [paymentMethodsData, setPaymentMethodsData] = useState<PaymentType[]>([]);
  const [loadingPaymentMethods, setLoadingPaymentMethods] = useState<boolean>(false);
  const [subscriptionPlansData, setSubscriptionPlansData] = useState<SubscriptionDetails[]>([]);
  const [validSubscriptionPlansData, setvalidSubscriptionPlansData] = useState<SubscriptionDetails[]>([]);
  const [selectedSubscriptionPlan, setSelectedSubscriptionPlan] = useState<SubscriptionDetails | null>(null);
  const [freeSubscriptionPlan, setFreeSubscriptionPlan] = useState<SubscriptionDetails | null>(null);
  const [showPlanFeatureModal, setShowPlanFeatureModal] = useState<boolean>(false);
  const swiperRef = useRef<SwiperType | null>(null)
  const [selectedProjectSubscription, setSelectedProjectSubscription] = useState<SubscriptionDetails | null>(null);

  const [isForRenewal, setIsForRenewal] = useState<boolean>(false);
  const [showReminderModal, setShowReminderModal] = useState<boolean>(false);

  const [searchKey, setSearchKey] = useState<string>('');
  /******************************************************************************************************/

  /* Check role */
  const [isInspector, setIsInspector] = useState<boolean>(false);
  const [isClient, setIsClient] = useState<boolean>(false);
  const [isDClient, setIsDClient] = useState<boolean>(false);

  useEffect(() => {
    const checkRole = async () => {
      const [inspectorResult, clientResult, dClientResult] = await Promise.all([
        checkIsBuildingInspector(),
        checkIsClient(),
        checkIsDClient(),
      ]);

      setIsInspector(inspectorResult);
      setIsClient(clientResult);
      setIsDClient(dClientResult);
    };

    checkRole();
  }, []);
  /*  */

  const useCanEdit = (screen: string, permission: string) => {
    return useSelector((state: RootState) =>
      hasPermission(state, screen, permission)
    );
  };

  const isPermissionAll = useCanEdit("Project Taps", "All");
  const isPermissionCurrent = useCanEdit("Project Taps", "Current");
  const isPermissionOngoing = useCanEdit("Project Taps", "Ongoing");
  const isPermissionCompleted = useCanEdit("Project Taps", "Completed");

  const isPermissionAddMultiProject = useCanEdit("Project", "add_multi_project");
  const isPermissionMultipleView = useCanEdit("Project", "multiple_view");
  const isPermissionAddSingleProject = useCanEdit("Project", "add_single_project");

  const isPermissionAddContactShortcut = useCanEdit("Project Details", "add_contact_shortcut");

  /* ******************************* For shared folder ******************************* */
  const [viewType, setViewType] = useState<"All" | "My project" | "Shared folder">("All");

  const [allProjectDataList, setAllProjectDataList] = useState<AllProjectAndSharedType[]>([]);
  const [filterProjectDataList, setFilterProjectDataList] = useState<AllProjectAndSharedType[]>([]);
  const [commonSearchKey, setCommonSearchKey] = useState<string>("");


  const [sharedFoldersData, setSharedFoldersData] = useState<SharedFolder[]>([]);
  const [filterSharedFoldersData, setFilterSharedFoldersData] = useState<SharedFolder[]>([]);
  const [selectedSharedFolders, setSelectedSharedFolders] = useState<SharedFolder[]>([]);
  const [selectedSharedContact, setSelectedSharedContact] = useState<SharedFolderBy | null>(null);
  const [showFolderMoveModal, setShowFolderMoveModal] = useState<boolean>(false);
  const [filteredProjectsData, setFilteredProjectsData] = useState<Project[]>([]);
  const [projectSearchkey, setProjectSearchkey] = useState<string>("");
  const [selectedProjectData, setSelectedProjectData] = useState<Project | null>(null);
  const [moveFolderLoading, setMoveFolderLoading] = useState<boolean>(false);
  const [folderSearchFilter, setFolderSearchFilter] = useState<string>("");


  /*************************************** useEffect For Project ******************************************/
  useEffect(() => {
    projectsDataGet();

    dispatch(fetchAllContact());
    dispatch(fetchAllUserRole());
  }, [dispatch]);

  const projectsDataGet = async () => {
    await dispatch(fetchAllProjects());
    setInitialProjectDataLoading(false);
  }

  useEffect(() => {
    calculateMinHeight();
    window.addEventListener("resize", calculateMinHeight);

    return () => {
      window.removeEventListener("resize", calculateMinHeight);
    };
  }, []);

  useEffect(() => {
    const choosedDataViewMode = localStorage.getItem("activeDataViewMode");
    if (choosedDataViewMode) {
      setDataViewMode(choosedDataViewMode);
    }
  }, []);

  // useEffect(() => {
  //   // BOS chnages donet remove this comment data , 

  //   // if (allProjects?.length === 0 && sharedFoldersData?.length === 0) {
  //   //   setViewType("My project");
  //   // } else if (allProjects?.length === 0) {
  //   //   setViewType("Shared folder");
  //   // } else {
  //   //   const choosedViewType = localStorage.getItem("activeProjectViewType") as "My project" | "Shared folder";
  //   //   setViewType(choosedViewType || "All");
  //   // }
  //    setViewType("All");
  // }, [allProjects, sharedFoldersData]);



  useEffect(() => {
    const choosedViewType = localStorage.getItem("activeProjectViewType") as "My project" | "Shared folder";
    setViewType(choosedViewType || "All");

    const myProjects: AllProjectAndSharedType[] = (allProjects || []).map((pro) =>
      mapAllProjectAndSharedType({
        projectData: pro,
        folderData: null,
        category: "My Project",
      })
    );

    const sharedProjects: AllProjectAndSharedType[] = (sharedFoldersData || []).map(
      (folder) =>
        mapAllProjectAndSharedType({
          projectData: null,
          folderData: folder,
          category: "Shared Folder",
        })
    );

    setAllProjectDataList([...myProjects, ...sharedProjects]);

  }, [allProjects, sharedFoldersData]);


  // all earch content
  useEffect(() => {
    if (!allProjectDataList || allProjectDataList.length === 0) {
      setFilterProjectDataList([]);
      return;
    }

    const searchKey = commonSearchKey.toLowerCase().trim();

    if (!searchKey) {
      setFilterProjectDataList(allProjectDataList);
      return;
    }

    const filteredProjects = allProjectDataList.filter((item) => {
      const project = item.projectData ?? item.folderData?.project;
      if (!project) return false;

      return (
        project.address?.toLowerCase().includes(searchKey) ||
        project.job_number?.toString().toLowerCase().includes(searchKey) ||
        project.post_code?.toLowerCase().includes(searchKey)
      );
    });

    setFilterProjectDataList(filteredProjects);

  }, [allProjectDataList, commonSearchKey]);






  useEffect(() => {
    if (!sharedFoldersData?.some(folder => folder.category === "Others")) {
      // setActiveCategory("Building Control");
      setActiveCategory("Others");

    } else if (!sharedFoldersData?.some(folder => folder.category === "Building Control")) {
      setActiveCategory("Others");
    } else {
      const choosedFolderCategory = localStorage.getItem("activeSharedFolderCategory") as 'Others' | 'Building Control';
      // setActiveCategory(choosedFolderCategory || "Others");
      setActiveCategory("Others");

    }
  }, [sharedFoldersData]);


  useEffect(() => {
    const choosedActiveTab = localStorage.getItem("activeProjectTab");
    if (choosedActiveTab) {
      setActiveTab(choosedActiveTab);
    } else {
      if (isPermissionAll) {
        setActiveTab("all");
      } if (isPermissionCurrent) {
        setActiveTab("current");
      } else if (isPermissionOngoing) {
        setActiveTab("ongoing");
      } else {
        setActiveTab("completed");
      }
    }
  }, [isPermissionAll, isPermissionCurrent, isPermissionOngoing]);

  const handleGetSubscriptionPlans = async (): Promise<SubscriptionDetails[] | []> => {
    const data = await subscriptionDetailsGetAPI();
    if (data.status) {
      setSubscriptionPlansData(data.data || []);

      const result: SubscriptionDetails[] = data.data || [];
      return result;
    } else {
      return [];
    }
  }

  useEffect(() => {
    handleGetSubscriptionPlans();
  }, []);

  useEffect(() => {
    const fetchProjectSubscriptionData = async () => {
      if (selectedProject && selectedProject !== null) {
        const subscription = subscriptionPlansData.find(
          (plan) => plan.subscription_id === selectedProject?.subscription_id
        );

        if (subscription && subscription.monthly_subscription_amount === 0) {
          // need to make loics

          // fetch payable subscriptions
          const payablesubscription = subscriptionPlansData.filter(
            (plan) => plan.monthly_subscription_amount !== 0
          );

          if (payablesubscription && payablesubscription.length > 0) {
            setSelectedProjectSubscription(payablesubscription[0]);
            // setSelectedSubscriptionPlan(payablesubscription[0]);
          }
        } else {
          setSelectedProjectSubscription(subscription || null);
          // setSelectedSubscriptionPlan(subscription || null);
        }
      }
    };

    fetchProjectSubscriptionData();
  }, [selectedProject, subscriptionPlansData]);


  useEffect(() => {
    if (subscriptionPlansData && subscriptionPlansData?.length > 0) {
      const validPlans = subscriptionPlansData.filter(plan => (plan.order_number >= selectedProjectSubscription?.order_number! && plan?.is_free === 0));

      if (validPlans && validPlans?.length > 0) {
        setvalidSubscriptionPlansData(validPlans);
        setSelectedSubscriptionPlan(validPlans[0])
      } else {
        setvalidSubscriptionPlansData([]);
        setSelectedSubscriptionPlan(null);
      }
    }
  }, [subscriptionPlansData, selectedProjectSubscription]);

  useEffect(() => {
    if (selectedSubscriptionPlan && swiperRef.current) {
      const index = validSubscriptionPlansData.findIndex(plan => plan.subscription_id === selectedSubscriptionPlan.subscription_id)
      if (index !== -1) {
        swiperRef.current.slideTo(index)
      }
    }
  }, [selectedSubscriptionPlan, validSubscriptionPlansData])

  useEffect(() => {
    const handleGetPaymentTypes = async () => {
      setLoadingPaymentMethods(true)
      const res = await getPaymentTypes();
      setLoadingPaymentMethods(false)

      if (res.status) {
        setPaymentMethodsData(mapPaymentTypes(res.body.data));
      }
    }
    handleGetPaymentTypes();
  }, []);

  const handleSelectSubscriptionPlan = (plan: SubscriptionDetails) => {
    setSelectedSubscriptionPlan(plan);
  }

  const handleClosePlanFeatureModal = () => {
    setShowPlanFeatureModal(false);
  }

  const handleViewPlanFeatures = () => {
    setShowPlanFeatureModal(true);
  }

  /**********************************************************************************************/

  /************************************* Assign Contact ****************************************/
  const handleAssignContact = async (e: React.FormEvent) => {
    e.preventDefault();

    const share: ShareContact[] = [];

    projectContacts.forEach((contact) => {
      if (contact.icChecked) {
        const shareCon: ShareContact = {
          by: contact.contactSubType,
          id: contact.id,
          // not need projects contacts add
          // can_edit:0
        };
        share.push(shareCon);
      }
    });

    setLoading(true);
    const res = await projectShareContact(selectedProject?.project_id!, share);
    setLoading(false);

    if (res.status) {
      projectsDataGet();
      setShowAssignContactModal(false);

      if (toast.current) {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: "Contact(s) assigned successfully.",
          life: 3000,
        });
      }
    } else {
      if (toast.current) {
        toast.current.show({
          severity: "error",
          summary: "Failed",
          detail: "Contact(s) assigned failed.",
          life: 3000,
        });
      }
    }
  };

  const handleViewAssignedContact = (project: Project) => {
    setShowViewAssignContactModal(true);
    setSelectedProject(project);
    if (project.contact.length > 0) {
      dispatch(setSelectedProjectBasicContact(project.contact[0]));
    }
  };

  const handleViewContact = (projectBasicContact: ProjectBasicContact) => {
    dispatch(setSelectedProjectBasicContact(projectBasicContact));
  };

  const handleViewAssignContact = (project: Project) => {
    setShowAssignContactModal(true);

    setSelectedProject(project);
    dispatch(setSelectedUserRole(null));
    dispatch(setSelectedUserType(null));
    dispatch(selectAddProjectContact(project));
    dispatch(setContactSearchKey(''));
    setSearchKey('')
  };

  /**********************************************************************************************/

  const handleToggleDataViewMode = () => {
    if (dataViewMode === "gridViewMode") {
      setDataViewMode("listViewMode");
      localStorage.setItem("activeDataViewMode", "listViewMode");
    } else if (dataViewMode === "listViewMode") {
      setDataViewMode("gridViewMode");
      localStorage.setItem("activeDataViewMode", "gridViewMode");
    }

    setSelectedAllProjectType(null);
    setSelectedCurrentProjectType(null);
    setSelectedOngoingProjectType(null);
    setSelectedCompletedProjectType(null);
  };

  //
  const handleTabChange = (tab: string): void => {
    setActiveTab(tab);
    localStorage.setItem("activeProjectTab", tab);
  };

  const handleTabCategoryChange = (tab: 'Others' | 'Building Control'): void => {
    setActiveCategory(tab);
    localStorage.setItem("activeSharedFolderCategory", tab);
  };

  const handleOpenModal = (state: "Add" | "Edit") => {
    setDataState(state);
    setModalOpen(true);
    setSelectedProject(null);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleCloseAlert = () => {
    setShowAlert(false);
  };

  const handleSuccess = (message: string) => {
    setSuccessMessage(message);
    setShowAlert(true);
    setTimeout(() => {
      setShowAlert(false);
    }, 3000);
  };

  const handleCheckForAssignContact = (projectContract: ProjectContact) => {
    dispatch(setCheckedProjectContactForAssign(projectContract));
  };

  const handleSelectUserType = (type: "Employee" | "Professional" | "Client" | null) => {
    dispatch(setSelectedUserType(type));
    dispatch(setContactSearchKey(''));
    setSearchKey('')
  };

  const handleSelectUserRole = (e: DropdownChangeEvent) => {
    dispatch(setSelectedUserRole(e.value));
  };

  const handleContactSearchKey = (e: string) => {
    setSearchKey(e)
    dispatch(setContactSearchKey(e))
  };

  const handleNavigateToProjectDetails = (project: Project) => {
    navigate(`/project/detail`, { state: { projectData: project } });
    localStorage.setItem("activeCategoryTab", 'Others');
    goToTop();
  };

  /* For Assign Contact */
  /* Modal header */
  const assignContactModalHeader = (
    <div className="custom_modal_header_inner">
      <h5 className="modal-title fs-5">Add project contact</h5>
      <button
        type="button"
        className="close_modal_btn p-ripple"
        onClick={() => setShowAssignContactModal(false)}
      >
        <i className="bi bi-x-circle"></i>
        <Ripple />
      </button>
    </div>
  );

  /* Modal footer */
  const assignContactModalFooter = (
    <div className="custom_modal_footer">
      <Button
        label="Close"
        className="custom_btn secondary"
        onClick={() => setShowAssignContactModal(false)}
      />
      <Button
        label={`${loading ? "Assigning" : "Assign"}`}
        loading={loading}
        onClick={handleAssignContact}
        className="custom_btn primary"
      />
    </div>
  );

  /* For View Assign Contact */
  /* Modal header */
  const viewAssignContactModalHeader = (
    <div className="custom_modal_header_inner">
      <h5 className="modal-title fs-5">Project contact</h5>
      <button
        type="button"
        className="close_modal_btn p-ripple"
        onClick={() => setShowViewAssignContactModal(false)}
      >
        <i className="bi bi-x-circle"></i>
        <Ripple />
      </button>
    </div>
  );

  // For showing selected role
  const selectedRoleTemplate = (option: Role, props: DropdownProps) => {
    if (option) {
      return (
        <div className="d-flex align-items-center">
          <div>{option.role_name}</div>
        </div>
      );
    }

    return <span>{props.placeholder}</span>;
  };

  // For showing role options in the dropdown list
  const roleOptionTemplate = (option: Role) => {
    return (
      <div className="d-flex align-items-center">
        <div>{option.role_name}</div>
      </div>
    );
  };

  // For showing selected user type
  const selectedUserTypeTemplate = (option: string, props: DropdownProps) => {
    if (option) {
      return (
        <div className="d-flex align-items-center">
          <div>{option}</div>
        </div>
      );
    }

    return <span>{props.placeholder}</span>;
  };

  // For showing user type options in the dropdown list
  const userTypeOptionTemplate = (option: string) => {
    return (
      <div className="d-flex align-items-center">
        <div>{option}</div>
      </div>
    );
  };

  const assignContact = () => {
    setShowAssignContactModal(true);
    setShowViewAssignContactModal(false);
    dispatch(setSelectedUserRole(null));
    dispatch(setSelectedUserType(null));
    dispatch(setContactSearchKey(''));
    setSearchKey('')
    dispatch(selectAddProjectContact(selectedProject!));
  };

  /**********************************************************************************************/

  /************************************ For Table view mode *************************************/
  const filterProjects = (
    projects: Project[],
    selectedType: string | null,
    search: string
  ): Project[] => {
    return projects.filter((project) => {
      const matchesType = selectedType ? project.project_type === selectedType : true;

      const matchesSearch = search
        ? project.job_number?.toString()?.toLowerCase().includes(search.toLowerCase()) ||
        project.address?.toLowerCase().includes(search.toLowerCase())
        : true;

      return matchesType && matchesSearch;
    });
  };

  const filteredAllProjects = filterProjects(allProjects, selectedAllProjectType, projectSearchFilter);
  const filteredCurrentProjects = filterProjects(currentProjects, selectedCurrentProjectType, projectSearchFilter);
  const filteredOngoingProjects = filterProjects(ongoingProjects, selectedOngoingProjectType, projectSearchFilter);
  const filteredCompletedProjects = filterProjects(completedProject, selectedCompletedProjectType, projectSearchFilter);

  /* For All projects */
  const onAllProjectTypeChange = (e: any) => {
    setSelectedAllProjectType(e.value);
  };

  const allProjectTypeFilterElement = (
    <Dropdown
      value={selectedAllProjectType}
      options={projetTypes}
      onChange={onAllProjectTypeChange}
      placeholder="Select"
      className="p-column-filter"
      showClear
    />
  );

  const allProjectTypeBody = (rowData: Project) => {
    const ProjectType = rowData.project_type;
    return <div className="table_row_data">{ProjectType}</div>;
  };

  const allProjectContactBody = (rowData: Project) => {
    const contacts = rowData.contact;
    const isProjectInactive: boolean = rowData?.this_project_active === 0;

    return (
      <div className="d-flex justify-content-start">
        <Tooltip
          key={`contact_for_all_${rowData.project_id}`}
          id={`contact_for_all_${rowData.project_id}`}
          target={`.contact_for_all_${rowData.project_id}`}
        />

        {contacts?.length > 0 ? (
          <div className={`project_card_contact_section ${isProjectInactive && "locked"}`}>
            <div
              className="project_card_contact_area mt-0 p-ripple"
              onClick={() => isProjectInactive === false ? handleViewAssignedContact(rowData) : undefined}
            >
              {contacts.slice(0, 3).map((contact) => (
                <div key={contact.id} className="project_card_contact">
                  {contact.first_name[0]}
                  {contact.last_name[0]}
                </div>
              ))}

              {contacts.length > 3 && (
                <h6 className="project_card_contact_has_more">
                  +{contacts.length - 3}
                </h6>
              )}
              <Ripple />
            </div>

            <div className="project_card_contact_add_area m-0 p-0">
              <button
                className={`contact_for_all_${rowData.project_id} p-ripple`}
                disabled={!isPermissionAddContactShortcut}
                onClick={() => isProjectInactive === false ? handleViewAssignContact(rowData) : undefined}
                data-pr-tooltip={`Assign contact(s)`}
                data-pr-position="top"
              >
                <i className="bi bi-plus"></i>
                <Ripple />
              </button>
            </div>
          </div>
        ) : (
          <div className="project_card_contact_add_area mt-0">
            <button
              className={`contact_for_curr_${rowData.project_id} p-ripple`}
              disabled={!isPermissionAddContactShortcut}
              onClick={() => isProjectInactive === false ? handleViewAssignContact(rowData) : undefined}
              data-pr-tooltip={`Assign contact(s)`}
              data-pr-position="top"
            >
              <i className="bi bi-plus"></i>
              <Ripple />
            </button>
          </div>
        )}
      </div>
    );
  };

  const allProjectViewBody = (rowData: Project) => {
    const isProjectInactive: boolean = rowData?.this_project_active === 0;

    return (
      <div className="tabel_btn_area">
        <button
          type="button"
          className="tabel_btn p-ripple"
          onClick={() => isProjectInactive === false ? handleNavigateToProjectDetails(rowData) : handleProjectLicenseRenewal(rowData)}
        >
          {isProjectInactive && <i className="ri-lock-fill me-2"></i>}
          {isProjectInactive ? "Renew" : "View"}
          <Ripple />
        </button>
      </div>
    );
  };

  const getRowClassNameForAllProject = (data: Project, options: { [key: string]: any }) => {
    const projectType = data.project_type;
    const status = data.status;
    const isProjectInactive: boolean = data?.this_project_active === 0;

    if (status === 'Current') {
      if (projectType === "Commercial") {
        if (isProjectInactive) {
          return "project_data_row current locked commercial ";
        } else {
          return "project_data_row current commercial";
        }
      } else if (projectType === "Domestic") {
        if (isProjectInactive) {
          return "project_data_row current locked domestic";
        } else {
          return "project_data_row current domestic";
        }
      }
      return "project_data_row current";
    } else if (status === 'Ongoing') {
      if (isProjectInactive) {
        return "project_data_row ongoing locked";
      } else {
        return "project_data_row ongoing";
      }
    } else if (status === 'Completed') {
      if (isProjectInactive) {
        return "project_data_row completed locked";
      } else {
        return "project_data_row completed";
      }
    }
  };
  /*  */


  /* For Current Project */
  const onCurrentProjectTypeChange = (e: any) => {
    setSelectedCurrentProjectType(e.value);
  };

  const currentProjectTypeFilterElement = (
    <Dropdown
      value={selectedCurrentProjectType}
      options={projetTypes}
      onChange={onCurrentProjectTypeChange}
      placeholder="Select"
      className="p-column-filter"
      showClear
    />
  );

  const currentProjectTypeBody = (rowData: Project) => {
    const ProjectType = rowData.project_type;
    return <div className="table_row_data">{ProjectType}</div>;
  };

  const currentProjectContactBody = (rowData: Project) => {
    const contacts = rowData.contact;
    const isProjectInactive: boolean = rowData?.this_project_active === 0;

    return (
      <div className="d-flex justify-content-start">
        <Tooltip
          key={`contact_for_curr_${rowData.project_id}`}
          id={`contact_for_curr_${rowData.project_id}`}
          target={`.contact_for_curr_${rowData.project_id}`}
        />

        {contacts?.length > 0 ? (
          <div className={`project_card_contact_section ${isProjectInactive && "locked"}`}>
            <div
              className="project_card_contact_area mt-0 p-ripple"
              onClick={() => isProjectInactive === false ? handleViewAssignedContact(rowData) : undefined}
            >
              {contacts.slice(0, 3).map((contact) => (
                <div key={contact.id} className="project_card_contact">
                  {contact.first_name[0]}
                  {contact.last_name[0]}
                </div>
              ))}

              {contacts.length > 3 && (
                <h6 className="project_card_contact_has_more">
                  +{contacts.length - 3}
                </h6>
              )}
              <Ripple />
            </div>

            <div className="project_card_contact_add_area m-0 p-0">
              <button
                className={`contact_for_curr_${rowData.project_id} p-ripple`}
                disabled={!isPermissionAddContactShortcut}
                onClick={() => isProjectInactive === false ? handleViewAssignContact(rowData) : undefined}
                data-pr-tooltip={`Assign contact(s)`}
                data-pr-position="top"
              >
                <i className="bi bi-plus"></i>
                <Ripple />
              </button>
            </div>
          </div>
        ) : (
          <div className="project_card_contact_add_area mt-0">
            <button
              className={`contact_for_curr_${rowData.project_id} p-ripple`}
              disabled={!isPermissionAddContactShortcut}
              onClick={() => isProjectInactive === false ? handleViewAssignContact(rowData) : undefined}
              data-pr-tooltip={`Assign contact(s)`}
              data-pr-position="top"
            >
              <i className="bi bi-plus"></i>
              <Ripple />
            </button>
          </div>
        )}
      </div>
    );
  };

  const currentProjectViewBody = (rowData: Project) => {
    const isProjectInactive: boolean = rowData?.this_project_active === 0;



    return (
      <div className="tabel_btn_area">
        <button
          type="button"
          className="tabel_btn p-ripple"
          onClick={() => isProjectInactive === false ? handleNavigateToProjectDetails(rowData) : handleProjectLicenseRenewal(rowData)}
        >
          {isProjectInactive && <i className="ri-lock-fill me-2"></i>}
          {isProjectInactive ? "Renew" : "View"}
          <Ripple />
        </button>
      </div>
    );
  };

  const getRowClassNameForCurrentProject = (data: Project, options: { [key: string]: any }) => {
    const projectType = data.project_type;
    const isProjectInactive: boolean = data?.this_project_active === 0;

    if (projectType === "Commercial") {
      if (isProjectInactive) {
        return "project_data_row current locked commercial ";
      } else {
        return "project_data_row current commercial";
      }
    } else if (projectType === "Domestic") {
      if (isProjectInactive) {
        return "project_data_row current locked domestic";
      } else {
        return "project_data_row current domestic";
      }
    }
    return "project_data_row current";
  };
  /*  */

  /* For Ongoing Project */
  const onOngoingProjectTypeChange = (e: any) => {
    setSelectedOngoingProjectType(e.value);
  };

  const ongoingProjectTypeFilterElement = (
    <Dropdown
      value={selectedOngoingProjectType}
      options={projetTypes}
      onChange={onOngoingProjectTypeChange}
      placeholder="Select"
      className="p-column-filter"
      showClear
    />
  );

  const ongoingProjectTypeBody = (rowData: Project) => {
    const ProjectType = rowData.project_type;
    return <div className="table_row_data">{ProjectType}</div>;
  };

  const ongoingProjectContactBody = (rowData: Project) => {
    const contacts = rowData.contact;
    const isProjectInactive: boolean = rowData?.this_project_active === 0;

    return (
      <div className="d-flex justify-content-center">
        <Tooltip
          key={`contact_for_ong_${rowData.project_id}`}
          id={`contact_for_ong_${rowData.project_id}`}
          target={`.contact_for_ong_${rowData.project_id}`}
        />

        {contacts?.length > 0 ? (
          <div className={`project_card_contact_section ${isProjectInactive && "locked"}`}>
            <div
              className="project_card_contact_area mt-0 p-ripple"
              onClick={() => isProjectInactive === false ? handleViewAssignedContact(rowData) : undefined}
            >
              {contacts.slice(0, 3).map((contact) => (
                <div key={contact.id} className="project_card_contact">
                  {contact.first_name[0]}
                  {contact.last_name[0]}
                </div>
              ))}

              {contacts.length > 3 && (
                <h6 className="project_card_contact_has_more">
                  +{contacts.length - 3}
                </h6>
              )}
              <Ripple />
            </div>
            <div className="project_card_contact_add_area mt-0">
              <button
                className={`contact_for_ong_${rowData.project_id} p-ripple`}
                onClick={() => isProjectInactive === false ? handleViewAssignContact(rowData) : undefined}
                disabled={!isPermissionAddContactShortcut}
                data-pr-tooltip={`Assign contact(s)`}
                data-pr-position="top"
              >
                <i className="bi bi-plus"></i>
                <Ripple />
              </button>
            </div>
          </div>
        ) : (
          <div className="project_card_contact_add_area mt-0">
            <button
              className={`contact_for_ong_${rowData.project_id} p-ripple`}
              disabled={!isPermissionAddContactShortcut}
              onClick={() => isProjectInactive === false ? handleViewAssignContact(rowData) : undefined}
              data-pr-tooltip={`Assign contact(s)`}
              data-pr-position="top"
            >
              <i className="bi bi-plus"></i>
              <Ripple />
            </button>
          </div>
        )}
      </div>
    );
  };

  const ongoingProjectViewBody = (rowData: Project) => {
    const isProjectInactive: boolean = rowData?.this_project_active === 0;

    return (
      <div className="tabel_btn_area">
        <button
          type="button"
          className="tabel_btn p-ripple"
          onClick={() => isProjectInactive === false ? handleNavigateToProjectDetails(rowData) : handleProjectLicenseRenewal(rowData)}
        >
          {isProjectInactive && <i className="ri-lock-fill me-2"></i>}
          {isProjectInactive ? "Renew" : "View"}
          <Ripple />
        </button>
      </div>
    );
  };

  const getRowClassNameForOngoingProject = (data: Project, options: { [key: string]: any }) => {
    const isProjectInactive: boolean = data?.this_project_active === 0;

    if (isProjectInactive) {
      return "project_data_row ongoing locked";
    } else {
      return "project_data_row ongoing";
    }
  };
  /*  */

  /* For Completed Project */
  const onCompletedProjectTypeChange = (e: any) => {
    setSelectedCompletedProjectType(e.value);
  };

  const completedProjectTypeFilterElement = (
    <Dropdown
      value={selectedCompletedProjectType}
      options={projetTypes}
      onChange={onCompletedProjectTypeChange}
      placeholder="Select"
      className="p-column-filter"
      showClear
    />
  );

  const completedProjectTypeBody = (rowData: Project) => {
    const ProjectType = rowData.project_type;
    return <div className="table_row_data">{ProjectType}</div>;
  };

  const completedProjectContactBody = (rowData: Project) => {
    const contacts = rowData.contact;
    const isProjectInactive: boolean = rowData?.this_project_active === 0;

    return (
      <div className="d-flex justify-content-center">
        <Tooltip
          key={`contact_for_com_${rowData.project_id}`}
          id={`contact_for_com_${rowData.project_id}`}
          target={`.contact_for_com_${rowData.project_id}`}
        />

        {contacts?.length > 0 ? (
          <div className={`project_card_contact_section ${isProjectInactive && "locked"}`}>
            <div
              className="project_card_contact_area mt-0 p-ripple"
              onClick={() => isProjectInactive === false ? handleViewAssignedContact(rowData) : undefined}
            >
              {contacts.slice(0, 3).map((contact) => (
                <div key={contact.id} className="project_card_contact">
                  {contact.first_name[0]}
                  {contact.last_name[0]}
                </div>
              ))}

              {contacts.length > 3 && (
                <h6 className="project_card_contact_has_more">
                  +{contacts.length - 3}
                </h6>
              )}
              <Ripple />
            </div>

            <div className="project_card_contact_add_area m-0 p-0">
              <button
                className={`contact_for_com_${rowData.project_id} p-ripple`}
                onClick={() => isProjectInactive === false ? handleViewAssignContact(rowData) : undefined}
                data-pr-tooltip={`Assign contact(s)`}
                data-pr-position="top"
              >
                <i className="bi bi-plus"></i>
                <Ripple />
              </button>
            </div>
          </div>
        ) : (
          <div className="project_card_contact_add_area mt-0">
            <button
              className={`contact_for_com_${rowData.project_id} p-ripple`}
              disabled={!isPermissionAddContactShortcut}
              onClick={() => isProjectInactive === false ? handleViewAssignContact(rowData) : undefined}
              data-pr-tooltip={`Assign contact(s)`}
              data-pr-position="top"
            >
              <i className="bi bi-plus"></i>
              <Ripple />
            </button>
          </div>
        )}
      </div>
    );
  };

  const completedProjectViewBody = (rowData: Project) => {
    const isProjectInactive: boolean = rowData?.this_project_active === 0;

    return (
      <div className="tabel_btn_area">
        <button
          type="button"
          className="tabel_btn p-ripple"
          onClick={() => isProjectInactive === false ? handleNavigateToProjectDetails(rowData) : handleProjectLicenseRenewal(rowData)}
        >
          {isProjectInactive && <i className="ri-lock-fill me-2"></i>}
          {isProjectInactive ? "Renew" : "View"}
          <Ripple />
        </button>
      </div>
    );
  };

  const getRowClassNameForCompletedProject = (data: Project, options: { [key: string]: any }) => {
    const isProjectInactive: boolean = data?.this_project_active === 0;

    if (isProjectInactive) {
      return "project_data_row completed locked";
    } else {
      return "project_data_row completed";
    }
  };
  /*  */
  /**********************************************************************************************/

  /**********************************************************************************************/

  //
  const [minHeight, setMinHeight] = useState<string>("0px");

  const calculateMinHeight = () => {
    const windowHeight = window.innerHeight;
    const distanceFromBottom = 200;
    const calculatedHeight = windowHeight - distanceFromBottom;
    setMinHeight(`${calculatedHeight}px`);
  };


  useEffect(() => {
    if (allProjects && allProjects?.length > 0) {
      const filteredProjects = allProjects.filter(
        (project) =>
          project
            ?.address!.toLowerCase()
            .includes(projectSearchkey.toLowerCase()) ||
          project
            ?.job_number!.toString()
            .toLowerCase()
            .includes(projectSearchkey.toLowerCase()) ||
          project
            ?.post_code!.toLowerCase()
            .includes(projectSearchkey.toLowerCase())
      );
      setFilteredProjectsData(filteredProjects);
    }
  }, [allProjects, projectSearchkey]);

  // for fetching data fro api tigger with state object actions
  useEffect(() => {
    sharedFolderDataGet();
  }, []);

  const sharedFolderDataGet = async () => {
    await dispatch(getSharedFoldersData());
    setInitialFolderDataLoading(false);
  }

  // this is get data from state list and set projectlist

  //   SHARE FOLDER PART 001
  const sharedFolders = useAppSelector((state) => state.shareFolderList.sharedFolders);
  const loadingSharedFolders = useAppSelector((state) => state.shareFolderList.loader);

  useEffect(() => {
    const fetchData = async () => {
      setSharedFoldersData(sharedFolders);
    };

    fetchData();
  }, [sharedFolders]);

  useEffect(() => {
    if (sharedFoldersData && sharedFoldersData.length > 0) {
      const list = sharedFoldersData.filter((e) => {
        const matchesCategory = e.category === activeCategory;

        const searchKey = folderSearchFilter.toLowerCase();

        const matchesSearch =
          !searchKey ||
          e.feature_name?.toLowerCase().includes(searchKey) ||
          e.service_name?.toLowerCase().includes(searchKey) ||
          e.project?.job_number?.toLowerCase().includes(searchKey) ||
          e.project?.address?.toLowerCase().includes(searchKey);

        return matchesCategory && matchesSearch;
      });

      setFilterSharedFoldersData(list);
    } else {
      setFilterSharedFoldersData([]);
    }
  }, [activeCategory, sharedFoldersData, folderSearchFilter]);


  const handleCloseFolderMoveModal = () => {
    setShowFolderMoveModal(false);
    setProjectSearchkey("");

    setSelectedProjectData(null);
  };

  const handleSelectProject = (project: Project) => {
    setSelectedProjectData(project);
  };

  //   database insert function here.
  const handleMoveFolder = async () => {
    if (selectedSharedFolders && selectedSharedFolders.length > 0) {
      setMoveFolderLoading(true);
      const data = await moveFolder(
        selectedProjectData?.project_id!,
        selectedSharedFolders
      );

      setMoveFolderLoading(false);
      if (data.statusCode === 200) {
        setSelectedSharedFolders([]);
        projectsDataGet();
        sharedFolderDataGet();

        handleCloseFolderMoveModal();

        if (toast.current) {
          toast.current.show({
            severity: "success",
            summary: "Success",
            detail: "You have successfully moved the folder(s).",
            life: 3000,
          });
        }
      } else {
        if (toast.current) {
          toast.current.show({
            severity: "error",
            summary: "Failed",
            detail: "There was an error moving the folder.",
            life: 3000,
          });
        }
      }
    }
  };

  const handleSwitchViewType = (type: "My project" | "Shared folder" | "All") => {
    setViewType(type);
    localStorage.setItem("activeProjectViewType", type);
    // localStorage.setItem("activeSharedFolderCategory", 'Others');
  };

  const handleNavigateFolder = (data: SharedFolder) => {
    const folder = data?.folder;
    const feature = data?.feature_key_name;

    const itemData = {
      project_id: data?.project_id,
      job_number: data?.project?.job_number,
      description: data?.project?.description,
      address: data?.project?.address,
      folder_id: data.folder_id,
      folder: data.folder,
      feature_name: data.feature_name,
      serviceAssignedContact: data.assign,
      serviceAssignedContactDetails: data.contact,
      projectAllContact: data?.project?.contact!,
      sharedBy: data.shared_by,
      filePath: data?.file_path,
      can_edit: data.can_edit
    };


    console.log("itemData", itemData);

    if (data.type === "Custom") {
      const serviceAssignedContact: ShareContact[] = mapShareContacts(
        data.assign as any
      );
      const itemData = {
        project_id: data.project?.project_id,
        job_number: data.project?.job_number,
        address: data.project?.address,
        description: data?.project?.description,
        folder_id: data.folder_id,
        folder: data.folder,
        service_name: data.service_name,
        feature_name: data.feature_name,
        folder_type: data.folder_type,
        serviceAssignedContact: serviceAssignedContact,
        projectAllContact: data?.project?.contact!,
        sharedBy: data.shared_by,
        filePath: data?.file_path,
        can_edit: data.can_edit
      };

      if (data.folder_type === "Doc Drawing") {
        navigate(`/project/detail/custom-service/document-drawing`, {
          state: { data: itemData, folderId: data.folder_id },
        });
      } else if (data.folder_type === "Drawing") {
        const serviceAssignedContact: ShareContact[] = mapShareContacts(
          data.assign as any
        );

        navigate(`/project/detail/custom-service/drawing`, {
          state: { data: itemData, folderId: data.folder_id },
        });
      } else {
        navigate(`/project/detail/custom-service/document`, {
          state: { data: itemData, folderId: data.folder_id },
        });
      }
    } else {
      if (folder === "Pre Comencencemet") {
        navigate(`detail/default-service/pre-commencement/${feature}`, {
          state: { data: itemData, folderId: data.folder_id },
        });
      } else if (folder === "Onsite") {
        // if (data.feature_key_name === 'site-visit') {
        //   setInfoMessage('This feature is currently under development and will be available soon.');
        //   handleShowInfoModal();
        // } else {
        navigate(`detail/default-service/onsite/${feature}`, {
          state: { data: itemData, folderId: data.folder_id },
        });
        // }
      } else {
        navigate(`detail/default-service/general/${feature}`, {
          state: { data: itemData, folderId: data.folder_id },
        });
      }
    }
  }

  const sharedFolderContactBody = (rowData: SharedFolder) => {
    const folderSharedBy = rowData.shared_by;
    return (
      <div className="d-flex justify-content-center">
        {folderSharedBy && folderSharedBy !== null && (
          <div className="project_card_contact_area no_pointing mt-0">
            <div
              className="project_card_contact view_contact p-ripple"
              onClick={(e) => {
                e.stopPropagation();
                handleViewContactInfo(e, folderSharedBy);
              }}
            >
              {folderSharedBy?.first_name && folderSharedBy?.first_name[0]}
              {folderSharedBy?.last_name && folderSharedBy?.last_name[0]}
              <Ripple />
            </div>
          </div>
        )}
      </div>
    );
  }


  // dinesh contribute

  const sharedDetailsBodyByProject = (rowData: AllProjectAndSharedType) => {
    const folderSharedBy = (rowData.category === "Shared Folder") ? rowData?.folderData?.shared_by : null;
    return (
      <div className="d-flex justify-content-center">
        {folderSharedBy && folderSharedBy !== null && (
          <div className="project_card_contact_area no_pointing mt-0">
            <div
              className="project_card_contact view_contact p-ripple"
              onClick={(e) => {
                e.stopPropagation();
                handleViewContactInfo(e, folderSharedBy);
              }}
            >
              {folderSharedBy?.first_name && folderSharedBy?.first_name[0]}
              {folderSharedBy?.last_name && folderSharedBy?.last_name[0]}
              <Ripple />
            </div>
          </div>
        )}
      </div>
    );
  }

  const sharedFolderViewBodyByAllProject = (rowData: AllProjectAndSharedType) => {
    if (rowData.category === "My Project") {
      const project = rowData?.projectData!;
      const isProjectInactive: boolean = rowData?.projectData?.this_project_active === 0;
      return (
        <div className="tabel_btn_area">
          <button
            type="button"
            className="tabel_btn p-ripple"
            onClick={() => isProjectInactive === false ? handleNavigateToProjectDetails(project) : handleProjectLicenseRenewal(project)}
          >
            {isProjectInactive && <i className="ri-lock-fill me-2"></i>}
            {isProjectInactive ? "Renew" : "View"}
            <Ripple />
          </button>
        </div>
      );
    } else {
      const sharedBy = rowData?.folderData!;
      return (
        <div className="tabel_btn_area">
          <button
            type="button"
            className="tabel_btn p-ripple"
            onClick={() => handleNavigateFolder(sharedBy)}
          >
            <i className="bi bi-folder-fill me-2"></i>
            View
            <Ripple />
          </button>
        </div>
      );
    }
  }



  // dinesh end

  const handleViewContactInfo = (
    e: React.MouseEvent<HTMLDivElement>,
    data: SharedFolderBy
  ) => {
    if (data) {
      setSelectedSharedContact(data);

      if (op.current) {
        op.current.hide();
        setTimeout(() => op.current?.show(e, e.currentTarget), 50);
      }
    } else {
      setSelectedSharedContact(null);
      op.current?.hide();
    }
  }

  const sharedFolderViewBody = (rowData: SharedFolder) => {
    return (
      <div className="tabel_btn_area">
        <button
          type="button"
          className="tabel_btn p-ripple"
          onClick={() => handleNavigateFolder(rowData)}
        >
          <i className="bi bi-folder-fill me-2"></i>
          View
          <Ripple />
        </button>
      </div>
    );
  }

  const handleOpenFolderMoveModal = () => {
    setShowFolderMoveModal(true);
  };
  /* ******************************************************************************* */

  const handleCloseProjectRenewalModal = () => {
    setShowProjectRenewalModal(false);
    setSelectedProject(null);

    setShowReminderModal(false);
  };

  // PROJECT RENEW OPTIONS.
  const handleProjectLicenseRenewal = (project: Project) => {
    // handleShowInfoModal();
    // setInfoMessage(
    //   "Project license renewal is currently under development on the web and will be available soon. In the meantime, you can access this feature on our mobile app."
    // );

    setShowProjectRenewalModal(true);

    if (project) {
      setSelectedProject(project);
    } else {
      setSelectedProject(null);
    }
  };

  /* For renewal/ purchase new subscription */
  const [showRenewalCheckoutForm, setShowRenewalCheckoutForm] = useState<boolean>(false);
  const [showPurchaseCheckoutForm, setShowPurchaseCheckoutForm] = useState<boolean>(false);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState<PaymentType | null>(null);
  const [paidsubTotal, setPaidSubTotal] = useState<number>(0);
  const [renewalPaidTotal, setRenewalPaidTotal] = useState<number>(0);
  const [paidTaxAmount, setTaxAmount] = useState<number>(0);

  const [purchasePaidTotal, setPurchasePaidTotal] = useState<number>(0);

  /* For nenewal */
  const handleRenewalPayWith = (paymentMethod: PaymentType) => {
    setSelectedPaymentMethod(paymentMethod);
    setPaidSubTotal(selectedProjectSubscription?.monthly_subscription_amount!);
    const taxAmount =
      selectedProjectSubscription?.monthly_subscription_amount! *
      (selectedProjectSubscription?.tax_percentage! / 100);
    setTaxAmount(taxAmount);
    const total = selectedProjectSubscription?.monthly_subscription_amount! + taxAmount;
    setRenewalPaidTotal(total);
    setShowRenewalCheckoutForm(true);
  };

  const handleRenewalPaymentSuccess = async (paymentIntent: PaymentIntent | undefined) => {
    if (paymentIntent?.status === "succeeded") {
      setShowRenewalCheckoutForm(false);
      setShowProjectRenewalModal(false);
      const discount: number = 0;

      const result = await projectRenew(
        selectedProject?.license_with_key_id!,
        selectedProjectSubscription?.subscription_id!,
        selectedPaymentMethod?.id!,
        paymentIntent.id,
        paidsubTotal,
        discount,
        paidTaxAmount,
        renewalPaidTotal
      );

      if (result.status) {
        projectsDataGet();

        if (toast.current) {
          toast.current.show({
            severity: "success",
            summary: "Success",
            detail: "Project renewed successfully.",
            life: 3000,
          });
        }
      } else {
        if (toast.current) {
          toast.current.show({
            severity: "error",
            summary: "Failed",
            detail: "Project renewed failed.",
            life: 3000,
          });
        }
      }

      // project renew data send.
    } else {
      if (toast.current) {
        toast.current.show({
          severity: "error",
          summary: "Failed",
          detail: "Faild to reaserve payment.",
          life: 3000,
        });
      }
    }
  };
  /*  */


  /* For purchase new subscription */
  const handlePurchasePayWith = (paymentMethod: PaymentType) => {
    setSelectedPaymentMethod(paymentMethod);
    const taxAmount = selectedSubscriptionPlan?.monthly_subscription_amount! * (selectedSubscriptionPlan?.tax_percentage! / 100);

    const total = selectedSubscriptionPlan?.monthly_subscription_amount! + taxAmount;
    setPurchasePaidTotal(total);
    setShowPurchaseCheckoutForm(true);
  };

  const handlePurchasePaymentSuccess = async (paymentIntent: PaymentIntent | undefined) => {
    if (paymentIntent?.status === "succeeded") {
      setShowPurchaseCheckoutForm(false);

      const buyLicenseResult = await buyLicense(
        selectedPaymentMethod?.id!,
        selectedSubscriptionPlan?.subscription_id!,
        paymentIntent.id,
      );

      if (buyLicenseResult.status) {
        const assignLicenseResult = await projectLicenseUpdateAPI(
          selectedProject?.project_id || 0,
          selectedSubscriptionPlan?.subscription_id || 0
        );

        if (assignLicenseResult.status) {
          handleCloseProjectRenewalModal();
          setSelectedSubscriptionPlan(null);
          setSelectedPaymentMethod(null);
          projectsDataGet();

          if (toast.current) {
            toast.current.show({
              severity: "success",
              summary: "Success",
              detail: "You have successfully purchased a subscription and your project license has been successfully renewed.",
              life: 3000,
            });
          }
        } else {
          if (toast.current) {
            toast.current.show({
              severity: "error",
              summary: "Failed",
              detail: "An error occurred while updating the project license.",
              life: 3000,
            });
          }
        }
      } else {
        if (toast.current) {
          toast.current.show({
            severity: "error",
            summary: "Failed",
            detail: "An error occurred in the purchase subscription.",
            life: 3000,
          });
        }
      }
    } else {
      if (toast.current) {
        toast.current.show({
          severity: "error",
          summary: "Failed",
          detail: "An error occurred in the purchase subscription.",
          life: 3000,
        });
      }
    }
  };
  /*  */

  const handleChangeLicence = () => {
    setModalOpen(true);
    setDataState("Renewal");
    setIsForRenewal(true);
  };

  // RENEW
  const projectRenewalModalHeader = (
    <div className="custom_modal_header_inner">
      <h5 className="modal-title fs-5">Renew</h5>
      <button
        type="button"
        className="close_modal_btn p-ripple"
        onClick={handleCloseProjectRenewalModal}
      >
        <i className="bi bi-x-circle"></i>
        <Ripple />
      </button>
    </div>
  );

  const projectRenewalModalFooter = (
    <div className="custom_modal_footer">
      <Button
        label="Cancel"
        className="custom_btn secondary"
        onClick={handleCloseProjectRenewalModal}
      />
    </div>
  );
  /* ******************************************************************************* */

  const [showInfoModal, setShowInfoModal] = useState<boolean>(false);
  const [infoMessage, setInfoMessage] = useState<string>("");

  const handleShowInfoModal = () => {
    setShowInfoModal(true);
  };

  const handleCloseInfoModal = () => {
    setShowInfoModal(false);
  };

  const goBack = () => {
    navigate(-1);
    goToTop();
  };


  const handleViewProjectReminder = (projct: Project) => {
    setShowReminderModal(true);
    setSelectedProject(projct);
  }

  const handleCloseReminderModal = () => {
    setShowReminderModal(false);
    setSelectedProject(null);
  };

  const reminderModalHeader = (
    <div className="custom_modal_header_inner">
      <h5 className="modal-title fs-5">
        Expiration info
      </h5>

      <button
        type="button"
        className="close_modal_btn p-ripple"
        onClick={handleCloseReminderModal}
      >
        <i className="bi bi-x-circle"></i>
        <Ripple />
      </button>
    </div>
  );

  const reminderModalFooter = (
    <div className="custom_modal_footer">
      {selectedProject && selectedProject !== null && (
        <React.Fragment>
          <Button
            label="Renew"
            onClick={() => handleProjectLicenseRenewal(selectedProject)}
            className="custom_btn primary"
          />

          <Button
            label={`Skip for
              ${selectedProject?.remaider_day_count === 0 ? ' now' : (selectedProject?.remaider_day_count + ' day' + (selectedProject?.remaider_day_count! > 1 ? 's' : ''))} 
              `}
            className="custom_btn secondary"
            onClick={handleCloseReminderModal}
          />
        </React.Fragment>
      )}
    </div>
  );

  useEffect(() => {
    if (subscriptionPlansData && subscriptionPlansData?.length > 0) {
      const freePlan = subscriptionPlansData?.filter(plan => plan?.is_free === 1);
      setFreeSubscriptionPlan(freePlan[0]);
    }
  }, [subscriptionPlansData]);


  const updateHeight = () => {
    if (contactListBodyRef.current) {
      setBodyHeight(contactListBodyRef.current.offsetHeight - 170);
    }
  };

  useEffect(() => {
    if (showAssignContactModal && contactListBodyRef.current) {
      updateHeight();

      window.addEventListener("resize", updateHeight);

      return () => {
        window.removeEventListener("resize", updateHeight);
      };
    }
  }, [showAssignContactModal, contactListBodyRef.current]);

  const EmptyProjectElement: React.FC<EmptyProjectElementProps> = ({ type, message }) => {
    let image = '';

    if (type === 'All') {
      image = 'no_data_img_purple.svg';
    } else if (type === 'Current') {
      image = 'no_data_img_purple.svg';
    } else if (type === 'Ongoing') {
      image = 'no_data_img_orange.svg';
    } else if (type === 'Completed') {
      image = 'no_data_img_green.svg';
    } else {
      image = 'no_data_img_purple.svg';
    }

    return (
      <div className="no_data_available_area">
        <img
          src={`/assets/images/no_data/${image}`}
          alt={message}
        />
        <h6>{message}</h6>
      </div>
    );
  };

  const checkDisableOption = (): boolean => {
    let optionDisabled = false;

    if (viewType === 'My project') {
      if (
        (activeTab === 'all' && allProjects?.length === 0) ||
        (activeTab === 'current' && currentProjects?.length === 0) ||
        (activeTab === 'ongoing' && ongoingProjects?.length === 0) ||
        (activeTab === 'completed' && completedProject?.length === 0)
      ) {
        optionDisabled = true;
      } else {
        optionDisabled = false;
      }
    } else if (viewType === 'Shared folder') {
      if (sharedFoldersData?.filter(folder => folder?.category === activeCategory)?.length === 0) {
        optionDisabled = true;
      } else {
        optionDisabled = false;
      }
    } else {
      optionDisabled = false;
    }

    return optionDisabled
  }

  return (
    <React.Fragment>
      <Toast ref={toast} />

      <OverlayPanel ref={op} className="contact_view_overlay" dismissable>
        {selectedSharedContact && selectedSharedContact !== null && (
          <div className="contact_view_area">
            {selectedSharedContact?.profile_image !== null ? (
              <Image
                className="contact_profile_img"
                src={selectedSharedContact?.profile_image}
                alt="Profile"
                preview
              />
            ) : (
              <div className="contact_profile_img">
                <i className="bi bi-person-fill person_icon"></i>
              </div>
            )}
            <div className="contact_slide_det">
              <h6>{selectedSharedContact.first_name}</h6>
              <p>{selectedSharedContact.last_name}</p>
            </div>
          </div>
        )}
      </OverlayPanel>

      <div className="main_content layout_padding show_side_bar">
        {(dataLoading && initialProjectDataLoading) || (loadingSharedFolders && initialFolderDataLoading) || loadingContact ? (
          <PageLoader />
        ) : error ? (
          <ErrorPage errorMessage={error} />
        ) : errorContact ? (
          <ErrorPage errorMessage={errorContact} />
        ) : (
          <div>
            <div className="d-flex align-items-center justify-content-between">
              <div className="main_heading_tab_area">


                <button
                  className={`main_heading_as_tab ${viewType === "All" && "active"} p-ripple is_btn`}
                  type="button"
                  role="tab"
                  onClick={() => handleSwitchViewType("All")}
                >
                  All
                  <Ripple />
                </button>


                <button
                  className={`main_heading_as_tab ${viewType === "My project" && "active"} p-ripple is_btn`}
                  type="button"
                  role="tab"
                  onClick={() => handleSwitchViewType("My project")}
                >
                  {isInspector ? 'Our projects' : 'My project'}
                  <Ripple />
                </button>

                <button
                  className={`main_heading_as_tab ${viewType === "Shared folder" && "active"} p-ripple is_btn`}
                  type="button"
                  role="tab"
                  onClick={() => handleSwitchViewType("Shared folder")}
                >
                  Shared folder
                  <Ripple />
                </button>
              </div>
            </div>

            {viewType === "All" ? (
              // for all views BOS need to change this concept.

              <div className="page_content">
                <div className="page_header_area">
                  <div className="contact_tabs_container">
                    <ul className="contact_tabs">



                    </ul>
                  </div>

                  <div className="page_action_area flex_wrap_right">
                    <div className="filter_input_group">
                      <IconField iconPosition="right">
                        {folderSearchFilter === "" ? (
                          <InputIcon className="bi bi-search"></InputIcon>
                        ) : (
                          <InputIcon
                            className="bi bi-x-lg search_clear_icon"
                            onClick={() => setFolderSearchFilter("")}
                          ></InputIcon>
                        )}

                        <InputText
                          key={`commonSearchKey`}
                          id="commonSearchKey"
                          value={commonSearchKey}
                          onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCommonSearchKey(e.target.value)}
                          className="custom_form_input filter_input"
                          placeholder="Search by folder name/project"
                          type="search"
                          disabled={checkDisableOption()}
                        />
                      </IconField>
                    </div>


                  </div>
                </div>

                <div className="page_main_content_section" style={{ minHeight: minHeight }}>
                  {filterProjectDataList?.length > 0 ? (
                    <DataTable
                      value={filterProjectDataList}
                      paginator
                      size="small"
                      rows={10}
                      rowsPerPageOptions={[5, 10, 25, 50]}
                      tableStyle={{ minWidth: "50rem" }}
                      paginatorDropdownAppendTo={"self"}
                      paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                      currentPageReportTemplate="{first} to {last} of {totalRecords}"
                      className="page_table p-0 p-sm-2"
                      rowHover
                      emptyMessage={''}
                      dataKey="folder_id"
                      scrollable
                      loading={false}
                    >


                      <Column
                        header="Type"
                        headerClassName="text_purple"
                        field="feature_name"
                        body={(rowData: AllProjectAndSharedType) => (
                          <span className="text_bold text_no_wrap text-capitalize">
                            {rowData.category}
                            {(rowData.category === "Shared Folder") && (
                              <span className={`draft_lable mt-1 text_purple`}>
                                {rowData?.folderData?.feature_name ? rowData?.folderData?.feature_name : rowData?.folderData?.service_name ? rowData?.folderData?.service_name : "---"}
                              </span>
                            )}
                          </span>
                        )}
                        style={{ width: "20%" }}
                      ></Column>

                      <Column
                        header="Project"
                        headerClassName="text_purple"
                        field="address"
                        body={(rowData: AllProjectAndSharedType) => (
                          <span className="text-capitalize">
                            <span className="text_bold">
                              {(rowData.category === "My Project") ? rowData?.projectData?.job_number : rowData?.folderData?.project?.job_number}:</span>&nbsp;{(rowData.category === "My Project") ? rowData?.projectData?.address : rowData?.folderData?.project?.address}
                          </span>
                        )}
                        style={{ width: "30%" }}
                      ></Column>

                      <Column
                        header="Project type"
                        alignHeader={'center'}
                        headerClassName="text_purple"
                        field="project_type"
                        body={(rowData: AllProjectAndSharedType) => (
                          <span className="text-capitalize flex_center">
                            {(rowData.category === "My Project") ? (rowData.projectData?.project_type === 'CP' ? 'Commercial' : 'Domestic') : (rowData.folderData?.project?.project_type === 'CP' ? 'Commercial' : 'Domestic')}

                          </span>
                        )}
                        style={{ width: "15%" }}
                      ></Column>

                      {/* <Column
                        header="Shared on"
                        headerClassName="text_purple"
                        alignHeader={'center'}
                        field="feature_name"
                        body={(rowData: SharedFolder) => (
                          <span className="text_no_wrap flex_center text-capitalize">
                            {rowData.shared_date ? rowData.shared_date : "---"}
                          </span>
                        )}
                        style={{ width: "15%" }}
                      ></Column> */}

                      <Column
                        header="Shared"
                        headerClassName="text_purple"
                        alignHeader="center"
                        body={sharedDetailsBodyByProject}
                        style={{ width: "15%" }}
                      ></Column>

                      <Column
                        body={sharedFolderViewBodyByAllProject}
                        alignHeader="center"
                        className="table_btn_area"
                        frozen
                        alignFrozen="right"
                      ></Column>
                    </DataTable>
                  ) : (
                    <EmptyProjectElement
                      type="Folder"
                      message={`There are currently no projects or shared folders available`}
                    />
                  )}
                </div>
              </div>
            ) : viewType === "My project" ? (
              <div className="page_content">
                <div className="page_header_area">
                  <div className="contact_tabs_container">
                    <ul
                      className="contact_tabs mb-3"
                      id="project-tabs"
                      role="tablist"
                    >
                      {isPermissionAll && (
                        <li className="contact_tab_item" role="presentation">
                          <button className={`contact_tab_btn p-ripple ${activeTab === "all" ? "active" : ""}`}
                            onClick={() => handleTabChange("all")}
                            id="all-tab"
                            data-bs-toggle="pill"
                            data-bs-target="#all"
                            type="button"
                            role="tab"
                            aria-controls="all"
                            aria-selected={activeTab === "all" ? true : false}
                          >
                            All&nbsp;:&nbsp;
                            {String(allProjects?.length).padStart(2, "0")}
                            <Ripple pt={{ root: { style: { background: "rgba(164, 96, 253, 0.2)" } } }} />
                          </button>
                        </li>
                      )}

                      {isPermissionCurrent && (
                        <li className="contact_tab_item" role="presentation">
                          <button className={`contact_tab_btn p-ripple ${activeTab === "current" ? "active" : ""}`}
                            onClick={() => handleTabChange("current")}
                            id="current-tab"
                            data-bs-toggle="pill"
                            data-bs-target="#current"
                            type="button"
                            role="tab"
                            aria-controls="current"
                            aria-selected={activeTab === "current" ? true : false}
                          >
                            Current&nbsp;:&nbsp;
                            {String(currentProjects?.length).padStart(2, "0")}
                            <Ripple pt={{ root: { style: { background: "rgba(164, 96, 253, 0.2)" } } }} />
                          </button>
                        </li>
                      )}

                      {isPermissionOngoing && (
                        <li className="contact_tab_item" role="presentation">
                          <button className={`contact_tab_btn p-ripple ${activeTab === "ongoing" ? "active" : ""}`}
                            onClick={() => handleTabChange("ongoing")}
                            id="ongoing-tab"
                            data-bs-toggle="pill"
                            data-bs-target="#ongoing"
                            type="button"
                            role="tab"
                            aria-controls="ongoing"
                            aria-selected={activeTab === "ongoing" ? true : false}
                          >
                            Ongoing&nbsp;:&nbsp;
                            {String(ongoingProjects?.length).padStart(2, "0")}
                            <Ripple pt={{ root: { style: { background: "rgba(164, 96, 253, 0.2)" } } }} />
                          </button>
                        </li>
                      )}

                      {isPermissionCompleted && (
                        <li className="contact_tab_item" role="presentation">
                          <button className={`contact_tab_btn p-ripple ${activeTab === "completed" ? "active" : ""}`}
                            onClick={() => handleTabChange("completed")}
                            id="completed-tab"
                            data-bs-toggle="pill"
                            data-bs-target="#completed"
                            type="button"
                            role="tab"
                            aria-controls="completed"
                            aria-selected={activeTab === "completed" ? true : false}
                          >
                            Completed&nbsp;:&nbsp;
                            {String(completedProject?.length).padStart(2, "0")}
                            <Ripple pt={{ root: { style: { background: "rgba(164, 96, 253, 0.2)" } } }} />
                          </button>
                        </li>
                      )}
                    </ul>
                  </div>

                  <div className="page_action_area flex_wrap_right">
                    <React.Fragment>
                      <button className="data_view_mode_btn p-ripple" onClick={handleToggleDataViewMode}
                        disabled={checkDisableOption()}>
                        <i className={`${dataViewMode === "gridViewMode" ? "ri-list-unordered" : "ri-layout-grid-fill"}`}></i>
                        <Ripple />
                      </button>

                      <div className="filter_input_group">
                        <IconField iconPosition="right">
                          {projectSearchFilter === "" ? (
                            <InputIcon className="bi bi-search"></InputIcon>
                          ) : (
                            <InputIcon
                              className="bi bi-x-lg search_clear_icon"
                              onClick={() => setProjectSearchFilter("")}
                            ></InputIcon>
                          )}

                          <InputText
                            key={`projectSearchFilter`}
                            id="projectSearchFilter"
                            value={projectSearchFilter}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setProjectSearchFilter(e.target.value)}
                            className="custom_form_input filter_input auto_width"
                            placeholder="Search by address/job no."
                            disabled={checkDisableOption()}
                            type="search"
                          />
                        </IconField>
                      </div>

                      {isPermissionAddMultiProject ? (
                        <button className="add_data_link_btn p-ripple" onClick={() => handleOpenModal("Add")}>
                          <i className="bi bi-plus-circle"></i>
                          <span>Add project</span>
                          <Ripple />
                        </button>
                      ) : isPermissionAddSingleProject ? (
                        <React.Fragment>
                          {allProjects?.length === 0 && isDClient ? (
                            <button
                              className="add_data_link_btn p-ripple"
                              onClick={() => handleOpenModal("Add")}
                            >
                              <i className="bi bi-plus-circle"></i>
                              <span>Add project</span>
                              <Ripple />
                            </button>
                          ) : null}
                        </React.Fragment>
                      ) : null}
                    </React.Fragment>
                  </div>
                </div>

                <div className="tab-content contact_tab_content" id="project-tabsContent">
                  {/* *********************************** For show all projects ********************************** */}
                  {isPermissionAll && (
                    <div
                      className={`tab-pane fade ${activeTab === "all" ? "show active" : ""}`}
                      id="all"
                      role="tabpanel"
                      aria-labelledby="all-tab"
                      tabIndex={0}
                    >
                      <div className="page_data_area" style={{ minHeight }}>
                        {dataLoading && (
                          <CustomTableLoader />
                        )}

                        {allProjects?.length > 0 ? (
                          <React.Fragment>
                            {dataViewMode === "gridViewMode" ? (
                              <React.Fragment>
                                {filteredAllProjects?.length > 0 ? (
                                  <div className={`projects_view_area_grid ${dataViewMode === "gridViewMode" ? "show" : "hide"}`}>
                                    <div className="row projects_view_area_row">
                                      {filteredAllProjects.map((project) => {
                                        const isProjectInactive: boolean = project?.this_project_active === 0;
                                        return (
                                          <React.Fragment>
                                            <Tooltip
                                              key={`all_pro_type_${project.project_id}`}
                                              id={`all_pro_type_${project.project_id}`}
                                              target={`.all_pro_type_${project.project_id}`}
                                            />

                                            <Tooltip
                                              key={`all_pro_contact_${project.project_id}`}
                                              id={`all_pro_contact_${project.project_id}`}
                                              target={`.all_pro_contact_${project.project_id}`}
                                            />

                                            {isProjectInactive && (
                                              <Tooltip
                                                key={`all_expired${project.project_id}`}
                                                id={`all_expired${project.project_id}`}
                                                target={`.all_expired${project.project_id}`}
                                                mouseTrack
                                              />
                                            )}

                                            <div
                                              className="col-12 col-sm-6 col-xl-6 col-xxl-4 projects_view_area_padding"
                                              key={`current_project_${project.project_id}`}
                                            >
                                              <article
                                                className={`project_view_card 
                                              ${(project?.status === 'Current' && project.project_type === "Commercial") ? "bg_blue"
                                                    : (project?.status === 'Current' && project.project_type === "Domestic") ? "bg_purple"
                                                      : project?.status === 'Ongoing' ? "bg_orange"
                                                        : project?.status === 'Completed' ? "bg_green" : ""} 
                                                ${isProjectInactive && `locked all_expired${project.project_id} p-ripple`}`
                                                }
                                                onClick={() => isProjectInactive ? handleProjectLicenseRenewal(project) : undefined}
                                                data-pr-tooltip="The project license has expired, click to renew."
                                                data-pr-position="top"
                                                data-pr-mousetrack
                                              >

                                                {project?.show_reminder && project?.this_project_active === 1 && (
                                                  <React.Fragment>
                                                    <Tooltip
                                                      key={`reminder_info${project.project_id}`}
                                                      id={`reminder_info${project.project_id}`}
                                                      target={`.reminder_info${project.project_id}`}
                                                    />

                                                    <i className={`bi bi-exclamation-triangle-fill reminder_icon reminder_info${project.project_id}`}
                                                      data-pr-tooltip="The project license is about to expire, click for more information."
                                                      data-pr-position="top"
                                                      onClick={() => handleViewProjectReminder(project)}
                                                    ></i>
                                                  </React.Fragment>
                                                )}

                                                <div
                                                  className="project_view_card_body p-ripple"
                                                  onClick={() => isProjectInactive === false ? handleNavigateToProjectDetails(project) : undefined}
                                                >
                                                  <div className="project_view_card_head">
                                                    <div className="project_view_card_head_top">
                                                      <h6>{project.job_number}</h6>
                                                      <h6
                                                        className={`all_pro_type_${project.project_id} cursor_info`}
                                                        data-pr-tooltip={project.project_type === "Commercial" ? "Commercial Project" : "Domestic Project"}
                                                        data-pr-position="top"
                                                      >
                                                        {project.project_type === "Commercial" ? "CP" : "DP"}
                                                      </h6>
                                                    </div>
                                                    <div className="project_view_body_area">
                                                      <h6>{project.address}</h6>
                                                      <div className="project_view_sub">
                                                        <div className="row">
                                                          {!isInspector && (
                                                            project.service_type.length > 0 && (
                                                              <div className="col-6 p-0 col_border_right mx-auto">
                                                                <p>
                                                                  {project.service_type[0].name}
                                                                </p>
                                                              </div>
                                                            )
                                                          )}

                                                          <div className={`${isInspector ? 'col-12' : 'col-6'} p-0 mx-auto`}>
                                                            <p>{project.status}</p>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <Ripple />
                                                  </div>
                                                </div>

                                                <div className="project_view_card_footer">
                                                  <div>
                                                    {project.contact?.length > 0 && (
                                                      <div
                                                        className="project_card_contact_area p-ripple"
                                                        onClick={() => isProjectInactive === false ? handleViewAssignedContact(project) : undefined}
                                                      >
                                                        {project.contact.slice(0, 3).map((contact) => (
                                                          <div
                                                            key={contact.id}
                                                            className="project_card_contact"
                                                          >
                                                            {contact.first_name[0]}
                                                            {contact.last_name[0]}
                                                          </div>
                                                        ))}

                                                        {project.contact.length > 3 && (
                                                          <h6 className="project_card_contact_has_more">
                                                            +
                                                            {project.contact.length - 3}
                                                          </h6>
                                                        )}
                                                        <Ripple />
                                                      </div>
                                                    )}
                                                  </div>

                                                  <div className="project_card_contact_add_area">
                                                    <button
                                                      className={`all_pro_contact_${project.project_id} p-ripple`}
                                                      disabled={!isPermissionAddContactShortcut}
                                                      onClick={() => isProjectInactive === false ? handleViewAssignContact(project) : undefined}
                                                      data-pr-tooltip={`Assign contact(s)`}
                                                      data-pr-position="left"
                                                    >
                                                      <i className="bi bi-plus"></i>
                                                      <Ripple />
                                                    </button>
                                                  </div>
                                                </div>
                                                {isProjectInactive && <Ripple />}
                                              </article>
                                            </div>
                                          </React.Fragment>
                                        );
                                      })}
                                    </div>
                                  </div>
                                ) : (
                                  <EmptyProjectElement
                                    type="All"
                                    message={projectSearchFilter ? 'No projects found matching your search.' : 'No project(s) found!'}
                                  />
                                )}
                              </React.Fragment>
                            ) : dataViewMode === "listViewMode" ? (
                              <div className={`projects_view_area_list ${dataViewMode === "listViewMode" ? "show" : "hide"}`}>
                                <DataTable
                                  value={filteredAllProjects}
                                  paginator
                                  size="small"
                                  rows={10}
                                  rowsPerPageOptions={[5, 10, 25, 50]}
                                  tableStyle={{ minWidth: "50rem" }}
                                  paginatorDropdownAppendTo={"self"}
                                  paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                                  currentPageReportTemplate="{first} to {last} of {totalRecords}"
                                  className="page_table p-0 p-sm-2"
                                  rowHover
                                  scrollable
                                  loading={dataLoading}
                                  rowClassName={getRowClassNameForAllProject}
                                  emptyMessage={projectSearchFilter ? 'No projects found matching your search.' : 'No project(s) found!'}
                                >
                                  <Column
                                    header="Job No."
                                    headerClassName="text_purple"
                                    field="job_number"
                                    style={{ width: "10%" }}
                                  ></Column>

                                  <Column
                                    header="Site address"
                                    headerClassName="text_purple"
                                    field="address"
                                    style={{ width: "30%" }}
                                  ></Column>

                                  <Column
                                    header="Project type"
                                    headerClassName="text_purple"
                                    body={allProjectTypeBody}
                                    style={{ width: "20%" }}
                                    filter
                                    showFilterMenuOptions={false}
                                    showFilterMatchModes={false}
                                    showAddButton={false}
                                    showApplyButton={false}
                                    showClearButton={false}
                                    filterElement={allProjectTypeFilterElement}
                                    filterMenuClassName="emplyoyee_type_filter_menu"
                                    filterMenuStyle={{ minWidth: "15rem" }}
                                  ></Column>

                                  <Column
                                    header="Project contact"
                                    headerClassName="text_purple"
                                    alignHeader="left"
                                    body={allProjectContactBody}
                                    style={{ width: "20%" }}
                                  ></Column>

                                  <Column
                                    body={allProjectViewBody}
                                    alignHeader="center"
                                    className="table_btn_area"
                                    frozen
                                    alignFrozen="right"
                                  ></Column>
                                </DataTable>
                              </div>
                            ) : null}
                          </React.Fragment>
                        ) : (
                          <EmptyProjectElement
                            type="All"
                            message={'No project(s) found!'}
                          />
                        )}
                      </div>
                    </div>
                  )}
                  {/* ************************************************************************************************ */}


                  {/* *********************************** For show current projects ********************************** */}
                  {isPermissionCurrent && (
                    <div
                      className={`tab-pane fade ${activeTab === "current" ? "show active" : ""}`}
                      id="current"
                      role="tabpanel"
                      aria-labelledby="current-tab"
                      tabIndex={0}
                    >
                      <div className="page_data_area" style={{ minHeight }}>
                        {dataLoading && (
                          <CustomTableLoader />
                        )}

                        {currentProjects?.length > 0 ? (
                          <React.Fragment>
                            {dataViewMode === "gridViewMode" ? (
                              <React.Fragment>
                                {filteredCurrentProjects?.length > 0 ? (
                                  <div className={`projects_view_area_grid ${dataViewMode === "gridViewMode" ? "show" : "hide"}`}>
                                    <div className="row projects_view_area_row">
                                      {filteredCurrentProjects.map((project) => {
                                        const isProjectInactive: boolean = project?.this_project_active === 0;
                                        return (
                                          <React.Fragment>
                                            <Tooltip
                                              key={`curr_pro_type_${project.project_id}`}
                                              id={`curr_pro_type_${project.project_id}`}
                                              target={`.curr_pro_type_${project.project_id}`}
                                            />

                                            <Tooltip
                                              key={`curr_pro_contact_${project.project_id}`}
                                              id={`curr_pro_contact_${project.project_id}`}
                                              target={`.curr_pro_contact_${project.project_id}`}
                                            />

                                            {isProjectInactive && (
                                              <Tooltip
                                                key={`curr_expired${project.project_id}`}
                                                id={`curr_expired${project.project_id}`}
                                                target={`.curr_expired${project.project_id}`}
                                                mouseTrack
                                              />
                                            )}

                                            <div
                                              className="col-12 col-sm-6 col-xl-6 col-xxl-4 projects_view_area_padding"
                                              key={`current_project_${project.project_id}`}
                                            >
                                              <article
                                                className={`project_view_card ${project.project_type === "Commercial" ? "bg_blue" : "bg_purple"} 
                                            ${isProjectInactive && `locked curr_expired${project.project_id} p-ripple`}`}
                                                onClick={() => isProjectInactive ? handleProjectLicenseRenewal(project) : undefined}
                                                data-pr-tooltip="The project license has expired, click to renew."
                                                data-pr-position="top"
                                                data-pr-mousetrack
                                              >

                                                {project?.show_reminder && project?.this_project_active === 1 && (
                                                  <React.Fragment>
                                                    <Tooltip
                                                      key={`reminder_info${project.project_id}`}
                                                      id={`reminder_info${project.project_id}`}
                                                      target={`.reminder_info${project.project_id}`}
                                                    />

                                                    <i className={`bi bi-exclamation-triangle-fill reminder_icon reminder_info${project.project_id}`}
                                                      data-pr-tooltip="The project license is about to expire, click for more information."
                                                      data-pr-position="top"
                                                      onClick={() => handleViewProjectReminder(project)}
                                                    ></i>
                                                  </React.Fragment>
                                                )}

                                                <div
                                                  className="project_view_card_body p-ripple"
                                                  onClick={() => isProjectInactive === false ? handleNavigateToProjectDetails(project) : undefined}
                                                >
                                                  <div className="project_view_card_head">
                                                    <div className="project_view_card_head_top">
                                                      <h6>{project.job_number}</h6>
                                                      <h6
                                                        className={`curr_pro_type_${project.project_id} cursor_info`}
                                                        data-pr-tooltip={project.project_type === "Commercial" ? "Commercial Project" : "Domestic Project"}
                                                        data-pr-position="top"
                                                      >
                                                        {project.project_type === "Commercial" ? "CP" : "DP"}
                                                      </h6>
                                                    </div>
                                                    <div className="project_view_body_area">
                                                      <h6>{project.address}</h6>
                                                      <div className="project_view_sub">
                                                        <div className="row">
                                                          {!isInspector && (
                                                            project.service_type.length > 0 && (
                                                              <div className="col-6 p-0 col_border_right mx-auto">
                                                                <p>
                                                                  {project.service_type[0].name}
                                                                </p>
                                                              </div>
                                                            )
                                                          )}

                                                          <div className="col-4 p-0 mx-auto">
                                                            <p>{project.status}</p>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <Ripple />
                                                  </div>
                                                </div>

                                                <div className="project_view_card_footer">
                                                  <div>
                                                    {project.contact?.length > 0 && (
                                                      <div
                                                        className="project_card_contact_area p-ripple"
                                                        onClick={() => isProjectInactive === false ? handleViewAssignedContact(project) : undefined}
                                                      >
                                                        {project.contact.slice(0, 3).map((contact) => (
                                                          <div
                                                            key={contact.id}
                                                            className="project_card_contact"
                                                          >
                                                            {contact.first_name[0]}&nbsp;{contact.last_name[0]}
                                                          </div>
                                                        ))}

                                                        {project.contact.length > 3 && (
                                                          <h6 className="project_card_contact_has_more">
                                                            +{project.contact.length - 3}
                                                          </h6>
                                                        )}
                                                        <Ripple />
                                                      </div>
                                                    )}
                                                  </div>

                                                  <div className="project_card_contact_add_area">
                                                    <button
                                                      className={`curr_pro_contact_${project.project_id} p-ripple`}
                                                      disabled={!isPermissionAddContactShortcut}
                                                      onClick={() => isProjectInactive === false ? handleViewAssignContact(project) : undefined}
                                                      data-pr-tooltip={`Assign contact(s)`}
                                                      data-pr-position="left"
                                                    >
                                                      <i className="bi bi-plus"></i>
                                                      <Ripple />
                                                    </button>
                                                  </div>
                                                </div>
                                                {isProjectInactive && <Ripple />}
                                              </article>
                                            </div>
                                          </React.Fragment>
                                        )
                                      })}
                                    </div>
                                  </div>
                                ) : (
                                  <EmptyProjectElement
                                    type="Current"
                                    message={projectSearchFilter ? 'No current projects found matching your search.' : 'No current project(s) found!'}
                                  />
                                )}
                              </React.Fragment>
                            ) : dataViewMode === "listViewMode" ? (
                              <div className={`projects_view_area_list ${dataViewMode === "listViewMode" ? "show" : "hide"}`}>
                                <DataTable
                                  value={filteredCurrentProjects}
                                  paginator
                                  size="small"
                                  rows={10}
                                  rowsPerPageOptions={[5, 10, 25, 50]}
                                  tableStyle={{ minWidth: "50rem" }}
                                  paginatorDropdownAppendTo={"self"}
                                  paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                                  currentPageReportTemplate="{first} to {last} of {totalRecords}"
                                  className="page_table p-0 p-sm-2"
                                  rowHover
                                  scrollable
                                  loading={dataLoading}
                                  rowClassName={getRowClassNameForCurrentProject}
                                  emptyMessage={projectSearchFilter ? 'No current projects found matching your search.' : 'No current project(s) found!'}
                                >
                                  <Column
                                    header="Job No."
                                    headerClassName="text_purple"
                                    field="job_number"
                                    style={{ width: "10%" }}
                                  ></Column>

                                  <Column
                                    header="Site address"
                                    headerClassName="text_purple"
                                    field="address"
                                    style={{ width: "30%" }}
                                  ></Column>

                                  <Column
                                    header="Project type"
                                    headerClassName="text_purple"
                                    body={currentProjectTypeBody}
                                    style={{ width: "20%" }}
                                    filter
                                    showFilterMenuOptions={false}
                                    showFilterMatchModes={false}
                                    showAddButton={false}
                                    showApplyButton={false}
                                    showClearButton={false}
                                    filterElement={currentProjectTypeFilterElement}
                                    filterMenuClassName="emplyoyee_type_filter_menu"
                                    filterMenuStyle={{ minWidth: "15rem" }}
                                  ></Column>

                                  <Column
                                    header="Project contact"
                                    headerClassName="text_purple"
                                    alignHeader="left"
                                    body={currentProjectContactBody}
                                    style={{ width: "20%" }}
                                  ></Column>

                                  <Column
                                    body={currentProjectViewBody}
                                    alignHeader="center"
                                    className="table_btn_area"
                                    frozen
                                    alignFrozen="right"
                                  ></Column>
                                </DataTable>
                              </div>
                            ) : null}
                          </React.Fragment>
                        ) : (
                          <EmptyProjectElement
                            type="Current"
                            message={'No current project(s) found!'}
                          />
                        )}
                      </div>
                    </div>
                  )}
                  {/* ************************************************************************************************ */}

                  {/* *********************************** For show ongoing projects ********************************** */}
                  {isPermissionOngoing && (
                    <div
                      className={`tab-pane fade ${activeTab === "ongoing" ? "show active" : ""}`}
                      id="ongoing"
                      role="tabpanel"
                      aria-labelledby="ongoing-tab"
                      tabIndex={0}
                    >
                      <div className="page_data_area" style={{ minHeight }}>
                        {dataLoading && (
                          <CustomTableLoader />
                        )}

                        {ongoingProjects?.length > 0 ? (
                          <React.Fragment>
                            {dataViewMode === "gridViewMode" ? (
                              <React.Fragment>
                                {filteredOngoingProjects?.length > 0 ? (
                                  <div className={`projects_view_area_grid ${dataViewMode === "gridViewMode" ? "show" : ""}`}>
                                    <div className="row projects_view_area_row">
                                      {filteredOngoingProjects.map((project) => {
                                        const isProjectInactive: boolean = project?.this_project_active === 0;

                                        return (
                                          <React.Fragment>
                                            <Tooltip
                                              key={`ong_pro_type_${project.project_id}`}
                                              id={`ong_pro_type_${project.project_id}`}
                                              target={`.ong_pro_type_${project.project_id}`}
                                            />

                                            <Tooltip
                                              key={`ong_pro_contact_${project.project_id}`}
                                              id={`ong_pro_contact_${project.project_id}`}
                                              target={`.ong_pro_contact_${project.project_id}`}
                                            />

                                            {isProjectInactive && (
                                              <Tooltip
                                                key={`ong_expired${project.project_id}`}
                                                id={`ong_expired${project.project_id}`}
                                                target={`.ong_expired${project.project_id}`}
                                                mouseTrack
                                              />
                                            )}

                                            <div
                                              className="col-12 col-sm-6 col-xl-6 col-xxl-4 projects_view_area_padding"
                                              key={project.project_id}
                                            >
                                              <article
                                                className={`project_view_card bg_orange 
                                              ${isProjectInactive && `locked ong_expired${project.project_id} p-ripple`}`}
                                                onClick={() => isProjectInactive ? handleProjectLicenseRenewal(project) : undefined}
                                                data-pr-tooltip="The project license has expired, click to renew."
                                                data-pr-position="top"
                                                data-pr-mousetrack
                                              >

                                                {project?.show_reminder && project?.this_project_active === 1 && (
                                                  <React.Fragment>
                                                    <Tooltip
                                                      key={`reminder_info${project.project_id}`}
                                                      id={`reminder_info${project.project_id}`}
                                                      target={`.reminder_info${project.project_id}`}
                                                    />

                                                    <i className={`bi bi-exclamation-triangle-fill reminder_icon reminder_info${project.project_id}`}
                                                      data-pr-tooltip="The project license is about to expire, click for more information."
                                                      data-pr-position="top"
                                                      onClick={() => handleViewProjectReminder(project)}
                                                    ></i>
                                                  </React.Fragment>
                                                )}

                                                <div
                                                  className="project_view_card_body p-ripple"
                                                  onClick={() => isProjectInactive === false ? handleNavigateToProjectDetails(project) : undefined}
                                                >
                                                  <div className="project_view_card_head">
                                                    <div className="project_view_card_head_top">
                                                      <h6>{project.job_number}</h6>
                                                      <h6
                                                        className={`ong_pro_type_${project.project_id} cursor_info`}
                                                        data-pr-tooltip={project.project_type === "Commercial" ? "Commercial Project" : "Domestic Project"}
                                                        data-pr-position="top"
                                                      >
                                                        {project.project_type === "Commercial" ? "CP" : "DP"}
                                                      </h6>
                                                    </div>
                                                    <div className="project_view_body_area">
                                                      <h6>{project.address}</h6>
                                                      <div className="project_view_sub">
                                                        <div className="row">
                                                          {!isInspector && (
                                                            project.service_type.length > 0 && (
                                                              <div className="col-6 p-0 col_border_right mx-auto">
                                                                <p>
                                                                  {project.service_type[0].name}
                                                                </p>
                                                              </div>
                                                            )
                                                          )}
                                                          <div className="col-4 p-0 mx-auto">
                                                            <p>{project.status}</p>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <Ripple />
                                                  </div>
                                                </div>
                                                <div className="project_view_card_footer">
                                                  <div>
                                                    {project.contact?.length >
                                                      0 && (
                                                        <div
                                                          className="project_card_contact_area p-ripple"
                                                          onClick={() => isProjectInactive === false ? handleViewAssignedContact(project) : undefined}
                                                        >
                                                          {project.contact.slice(0, 3).map((contact) => (
                                                            <div
                                                              key={contact.id}
                                                              className="project_card_contact"
                                                            >
                                                              {contact.first_name[0]}&nbsp;{contact.last_name[0]}
                                                            </div>
                                                          ))}

                                                          {project.contact.length > 3 && (
                                                            <h6 className="project_card_contact_has_more">
                                                              +{project.contact.length - 3}
                                                            </h6>
                                                          )}
                                                          <Ripple />
                                                        </div>
                                                      )}
                                                  </div>

                                                  <div className="project_card_contact_add_area">
                                                    <button
                                                      className={`ong_pro_contact_${project.project_id} p-ripple`}
                                                      disabled={!isPermissionAddContactShortcut}
                                                      onClick={() => isProjectInactive === false ? handleViewAssignContact(project) : undefined}
                                                      data-pr-tooltip={`Assign contact(s)`}
                                                      data-pr-position="left"
                                                    >
                                                      <i className="bi bi-plus"></i>
                                                      <Ripple />
                                                    </button>
                                                  </div>
                                                </div>
                                                {isProjectInactive && <Ripple />}
                                              </article>
                                            </div>
                                          </React.Fragment>
                                        );
                                      })}
                                    </div>
                                  </div>
                                ) : (
                                  <EmptyProjectElement
                                    type="Ongoing"
                                    message={projectSearchFilter ? 'No ongoing projects found matching your search.' : 'No ongoing project(s) found!'}
                                  />
                                )}
                              </React.Fragment>
                            ) : dataViewMode === "listViewMode" ? (
                              <div className={`projects_view_area_list ${dataViewMode === "listViewMode" ? "show" : ""}`}>
                                <DataTable
                                  value={filteredOngoingProjects}
                                  paginator
                                  size="small"
                                  rows={10}
                                  rowsPerPageOptions={[5, 10, 25, 50]}
                                  tableStyle={{ minWidth: "50rem" }}
                                  paginatorDropdownAppendTo={"self"}
                                  paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                                  currentPageReportTemplate="{first} to {last} of {totalRecords}"
                                  className="page_table p-0 p-sm-2"
                                  rowHover
                                  scrollable
                                  loading={dataLoading}
                                  rowClassName={getRowClassNameForOngoingProject}
                                  emptyMessage={projectSearchFilter ? 'No ongoing projects found matching your search.' : 'No ongoing project(s) found!'}
                                >
                                  <Column
                                    header="Job No."
                                    headerClassName="text_purple"
                                    field="job_number"
                                    style={{ width: "10%" }}
                                  ></Column>

                                  <Column
                                    header="Site address"
                                    headerClassName="text_purple"
                                    field="address"
                                    style={{ width: "30%" }}
                                  ></Column>

                                  <Column
                                    header="Project type"
                                    headerClassName="text_purple"
                                    body={ongoingProjectTypeBody}
                                    style={{ width: "20%" }}
                                    filter
                                    showFilterMenuOptions={false}
                                    showFilterMatchModes={false}
                                    showAddButton={false}
                                    showApplyButton={false}
                                    showClearButton={false}
                                    filterElement={ongoingProjectTypeFilterElement}
                                    filterMenuClassName="emplyoyee_type_filter_menu"
                                    filterMenuStyle={{ minWidth: "15rem" }}
                                  ></Column>

                                  <Column
                                    header="Project contact"
                                    headerClassName="text_purple"
                                    alignHeader="center"
                                    body={ongoingProjectContactBody}
                                    style={{ width: "20%" }}
                                  ></Column>

                                  <Column
                                    body={ongoingProjectViewBody}
                                    alignHeader="center"
                                    className="table_btn_area"
                                    frozen
                                    alignFrozen="right"
                                  ></Column>
                                </DataTable>
                              </div>
                            ) : null}
                          </React.Fragment>
                        ) : (
                          <EmptyProjectElement
                            type="Ongoing"
                            message={'No ongoing project(s) found!'}
                          />
                        )}
                      </div>
                    </div>
                  )}
                  {/* ************************************************************************************************ */}

                  {/* ********************************** For show completed projects ********************************* */}
                  {isPermissionCompleted && (
                    <div
                      className={`tab-pane fade ${activeTab === "completed" ? "show active" : ""}`}
                      id="completed"
                      role="tabpanel"
                      aria-labelledby="completed-tab"
                      tabIndex={0}
                    >
                      <div className="page_data_area" style={{ minHeight }}>
                        {dataLoading && (
                          <CustomTableLoader />
                        )}

                        {completedProject?.length > 0 ? (
                          <React.Fragment>
                            {dataViewMode === "gridViewMode" ? (
                              <React.Fragment>
                                {filteredCompletedProjects?.length > 0 ? (
                                  <div className={`projects_view_area_grid ${dataViewMode === "gridViewMode" ? "show" : ""}`}>
                                    <div className="row projects_view_area_row">
                                      {filteredCompletedProjects.map((project) => {
                                        const isProjectInactive: boolean = project?.this_project_active === 0;
                                        return (
                                          <React.Fragment>
                                            <Tooltip
                                              key={`com_pro_type_${project.project_id}`}
                                              id={`com_pro_type_${project.project_id}`}
                                              target={`.com_pro_type_${project.project_id}`}
                                            />

                                            <Tooltip
                                              key={`com_pro_contact_${project.project_id}`}
                                              id={`com_pro_contact_${project.project_id}`}
                                              target={`.com_pro_contact_${project.project_id}`}
                                            />

                                            {isProjectInactive && (
                                              <Tooltip
                                                key={`com_expired${project.project_id}`}
                                                id={`com_expired${project.project_id}`}
                                                target={`.com_expired${project.project_id}`}
                                                mouseTrack
                                              />
                                            )}

                                            <div
                                              className="col-12 col-sm-6 col-xl-6 col-xxl-4 projects_view_area_padding"
                                              key={project.project_id}
                                            >
                                              <article
                                                className={`project_view_card bg_green
                                              ${isProjectInactive && `locked com_expired${project.project_id} p-ripple`}`}
                                                onClick={() => isProjectInactive ? handleProjectLicenseRenewal(project) : undefined}
                                                data-pr-tooltip="The project license has expired, click to renew."
                                                data-pr-position="top"
                                                data-pr-mousetrack
                                              >

                                                {project?.show_reminder && project?.this_project_active === 1 && (
                                                  <React.Fragment>
                                                    <Tooltip
                                                      key={`reminder_info${project.project_id}`}
                                                      id={`reminder_info${project.project_id}`}
                                                      target={`.reminder_info${project.project_id}`}
                                                    />

                                                    <i className={`bi bi-exclamation-triangle-fill reminder_icon reminder_info${project.project_id}`}
                                                      data-pr-tooltip="The project license is about to expire, click for more information."
                                                      data-pr-position="top"
                                                      onClick={() => handleViewProjectReminder(project)}
                                                    ></i>
                                                  </React.Fragment>
                                                )}

                                                <div
                                                  className="project_view_card_body p-ripple"
                                                  onClick={() => isProjectInactive === false ? handleNavigateToProjectDetails(project) : undefined}
                                                >
                                                  <div className="project_view_card_head">
                                                    <div className="project_view_card_head_top">
                                                      <h6>{project.job_number}</h6>
                                                      <h6
                                                        className={`com_pro_type_${project.project_id} cursor_info`}
                                                        data-pr-tooltip={project.project_type === "Commercial" ? "Commercial Project" : "Domestic Project"}
                                                        data-pr-position="top"
                                                      >
                                                        {project.project_type === "Commercial" ? "CP" : "DP"}
                                                      </h6>
                                                    </div>
                                                    <div className="project_view_body_area">
                                                      <h6>{project.address}</h6>
                                                      <div className="project_view_sub">
                                                        <div className="row">
                                                          {!isInspector && (
                                                            project.service_type.length > 0 && (
                                                              <div className="col-6 p-0 col_border_right mx-auto">
                                                                <p>
                                                                  {project.service_type[0].name}
                                                                </p>
                                                              </div>
                                                            )
                                                          )}

                                                          <div className="col-4 p-0 mx-auto">
                                                            <p>{project.status}</p>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <Ripple />
                                                  </div>
                                                </div>
                                                <div className="project_view_card_footer">
                                                  <div>
                                                    {project.contact?.length > 0 && (
                                                      <div
                                                        className="project_card_contact_area p-ripple"
                                                        onClick={() => isProjectInactive === false ? handleViewAssignedContact(project) : undefined}
                                                      >
                                                        {project.contact.slice(0, 3).map((contact) => (
                                                          <div
                                                            key={contact.id}
                                                            className="project_card_contact"
                                                          >
                                                            {contact.first_name[0]}&nbsp;{contact.last_name[0]}
                                                          </div>
                                                        ))}

                                                        {project.contact.length > 3 && (
                                                          <h6 className="project_card_contact_has_more">
                                                            +{project.contact.length - 3}
                                                          </h6>
                                                        )}
                                                        <Ripple />
                                                      </div>
                                                    )}
                                                  </div>

                                                  <div className="project_card_contact_add_area">
                                                    <button
                                                      className={`com_pro_contact_${project.project_id} p-ripple`}
                                                      disabled={!isPermissionAddContactShortcut}
                                                      onClick={() => isProjectInactive === false ? handleViewAssignContact(project) : undefined}
                                                      data-pr-tooltip={`Assign contact(s)`}
                                                      data-pr-position="left"
                                                    >
                                                      <i className="bi bi-plus"></i>
                                                      <Ripple />
                                                    </button>
                                                  </div>
                                                </div>
                                                {isProjectInactive && <Ripple />}
                                              </article>
                                            </div>
                                          </React.Fragment>
                                        )
                                      })}
                                    </div>
                                  </div>
                                ) : (
                                  <EmptyProjectElement
                                    type="Completed"
                                    message={projectSearchFilter ? 'No completed projects found matching your search.' : 'No completed project(s) found!'}
                                  />
                                )}
                              </React.Fragment>
                            ) : dataViewMode === "listViewMode" ? (
                              <div className={`projects_view_area_list ${dataViewMode === "listViewMode" ? "show" : ""}`}>
                                <DataTable
                                  value={filteredCompletedProjects}
                                  paginator
                                  size="small"
                                  rows={10}
                                  rowsPerPageOptions={[5, 10, 25, 50]}
                                  tableStyle={{ minWidth: "50rem" }}
                                  paginatorDropdownAppendTo={"self"}
                                  paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                                  currentPageReportTemplate="{first} to {last} of {totalRecords}"
                                  className="page_table p-0 p-sm-2"
                                  rowHover
                                  rowClassName={getRowClassNameForCompletedProject}
                                  scrollable
                                  loading={dataLoading}
                                  emptyMessage={projectSearchFilter ? 'No completed projects found matching your search.' : 'No completed project(s) found!'}
                                >
                                  <Column
                                    header="Job No."
                                    headerClassName="text_purple"
                                    field="job_number"
                                    style={{ width: "10%" }}
                                  ></Column>

                                  <Column
                                    header="Site address"
                                    headerClassName="text_purple"
                                    field="address"
                                    style={{ width: "30%" }}
                                  ></Column>

                                  <Column
                                    header="Project type"
                                    headerClassName="text_purple"
                                    body={completedProjectTypeBody}
                                    style={{ width: "20%" }}
                                    filter
                                    showFilterMenuOptions={false}
                                    showFilterMatchModes={false}
                                    showAddButton={false}
                                    showApplyButton={false}
                                    showClearButton={false}
                                    filterElement={completedProjectTypeFilterElement}
                                    filterMenuClassName="emplyoyee_type_filter_menu"
                                    filterMenuStyle={{ minWidth: "15rem" }}
                                  ></Column>

                                  <Column
                                    header="Project contact"
                                    headerClassName="text_purple"
                                    alignHeader="center"
                                    body={completedProjectContactBody}
                                    style={{ width: "20%" }}
                                  ></Column>

                                  <Column
                                    body={completedProjectViewBody}
                                    alignHeader="center"
                                    className="table_btn_area"
                                    frozen
                                    alignFrozen="right"
                                  ></Column>
                                </DataTable>
                              </div>
                            ) : null}
                          </React.Fragment>
                        ) : (
                          <EmptyProjectElement
                            type="Completed"
                            message={'No completed project(s) found!'}
                          />
                        )}
                      </div>
                    </div>
                  )}
                  {/* ************************************************************************************************ */}
                </div>
              </div>
            ) : viewType === "Shared folder" ? (
              <div className="page_content">
                <div className="page_header_area">
                  <div className="contact_tabs_container">
                    {/* boss said not need this  */}
                    {/* <ul className="contact_tabs">
                      <li className="contact_tab_item">
                        <button
                          className={`contact_tab_btn p-ripple ${activeCategory === "Others" ? "active" : ""}`}
                          onClick={() => handleTabCategoryChange("Others")}
                          type="button"
                          role="tab"
                        >
                          Others
                          <Ripple pt={{ root: { style: { background: "rgba(164, 96, 253, 0.2)" } } }}
                          />
                        </button>
                      </li>

                      <li className="contact_tab_item">
                        <button
                          className={`contact_tab_btn p-ripple ${activeCategory === "Building Control" ? "active" : ""}`}
                          onClick={() => handleTabCategoryChange("Building Control")}
                          type="button"
                          role="tab"
                        >
                          Building Control
                          <Ripple pt={{ root: { style: { background: "rgba(164, 96, 253, 0.2)" } } }}
                          />
                        </button>
                      </li>
                    </ul> */}
                  </div>

                  <div className="page_action_area flex_wrap_right">
                    <div className="filter_input_group">
                      <IconField iconPosition="right">
                        {folderSearchFilter === "" ? (
                          <InputIcon className="bi bi-search"></InputIcon>
                        ) : (
                          <InputIcon
                            className="bi bi-x-lg search_clear_icon"
                            onClick={() => setFolderSearchFilter("")}
                          ></InputIcon>
                        )}

                        <InputText
                          key={`folderSearchFilter`}
                          id="folderSearchFilter"
                          value={folderSearchFilter}
                          onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFolderSearchFilter(e.target.value)}
                          className="custom_form_input filter_input"
                          placeholder="Search by folder name/project"
                          type="search"
                          disabled={checkDisableOption()}
                        />
                      </IconField>
                    </div>

                    {selectedSharedFolders && selectedSharedFolders?.length > 0 && (
                      <React.Fragment>
                        <button
                          className="add_data_link_btn p-ripple"
                          onClick={handleOpenFolderMoveModal}
                        >
                          <i className="bi bi-arrow-up-right-square"></i>
                          <span>
                            Move folder
                            {selectedSharedFolders?.length > 1 ? "s" : ""} (
                            {selectedSharedFolders?.length})
                          </span>
                          <Ripple />
                        </button>
                      </React.Fragment>
                    )}
                  </div>
                </div>

                <div className="page_main_content_section" style={{ minHeight: minHeight }}>
                  {sharedFoldersData?.length > 0 ? (
                    <DataTable
                      value={filterSharedFoldersData}
                      paginator
                      size="small"
                      rows={10}
                      rowsPerPageOptions={[5, 10, 25, 50]}
                      tableStyle={{ minWidth: "50rem" }}
                      paginatorDropdownAppendTo={"self"}
                      paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                      currentPageReportTemplate="{first} to {last} of {totalRecords}"
                      className="page_table p-0 p-sm-2"
                      rowHover
                      emptyMessage={folderSearchFilter ? 'No folder(s) found matching your search.' : `No ${activeCategory === 'Others' ? 'other' : 'building control'} folders are shared!`}
                      selectionMode={"multiple"}
                      dragSelection
                      selection={selectedSharedFolders}
                      onSelectionChange={(e: DataTableSelectionMultipleChangeEvent<SharedFolder[]>) => setSelectedSharedFolders(e.value as SharedFolder[])}
                      dataKey="folder_id"
                      scrollable
                      loading={loadingSharedFolders}
                    >
                      <Column
                        selectionMode="multiple"
                        headerStyle={{ width: "3rem" }}
                      ></Column>

                      <Column
                        header="Folder"
                        headerClassName="text_purple"
                        field="feature_name"
                        body={(rowData: SharedFolder) => (
                          <span className="text_bold text_no_wrap text-capitalize">
                            {rowData.feature_name ? rowData.feature_name : rowData.service_name ? rowData.service_name : "---"}
                          </span>
                        )}
                        style={{ width: "20%" }}
                      ></Column>

                      <Column
                        header="Project"
                        headerClassName="text_purple"
                        field="address"
                        body={(rowData: SharedFolder) => (
                          <span className="text-capitalize">
                            <span className="text_bold">{rowData?.project?.job_number}:</span>&nbsp;{rowData.project?.address}
                          </span>
                        )}
                        style={{ width: "30%" }}
                      ></Column>

                      <Column
                        header="Project type"
                        alignHeader={'center'}
                        headerClassName="text_purple"
                        field="project_type"
                        body={(rowData: SharedFolder) => (
                          <span className="text-capitalize flex_center">
                            {rowData.project?.project_type === 'CP' ? 'Commercial' : 'Domestic'}
                          </span>
                        )}
                        style={{ width: "15%" }}
                      ></Column>

                      <Column
                        header="Shared on"
                        headerClassName="text_purple"
                        alignHeader={'center'}
                        field="feature_name"
                        body={(rowData: SharedFolder) => (
                          <span className="text_no_wrap flex_center text-capitalize">
                            {rowData.shared_date ? rowData.shared_date : "---"}
                          </span>
                        )}
                        style={{ width: "15%" }}
                      ></Column>

                      <Column
                        header="Shared by"
                        headerClassName="text_purple"
                        alignHeader="center"
                        body={sharedFolderContactBody}
                        style={{ width: "15%" }}
                      ></Column>

                      <Column
                        body={sharedFolderViewBody}
                        alignHeader="center"
                        className="table_btn_area"
                        frozen
                        alignFrozen="right"
                      ></Column>
                    </DataTable>
                  ) : (
                    <EmptyProjectElement
                      type="Folder"
                      message={`No ${activeCategory === 'Others' ? 'other' : 'building control'} folders are shared!`}
                    />
                  )}
                </div>
              </div>
            ) : null}
          </div>
        )}

        {/* ***************************************** Project modal **************************************** */}
        <ProjectModal
          isOpen={isModalOpen}
          dataState={dataState}
          onClose={handleCloseModal}
          onSuccess={handleSuccess}
          onRenewalClose={handleCloseProjectRenewalModal}
          toast={toast}
          projectDetails={selectedProject!}
        />
        {/*  */}
        {/* ************************************************************************************************ */}


        {/* ************************************* Assign Employee modal ************************************ */}
        <Dialog
          visible={showAssignContactModal}
          header={assignContactModalHeader}
          footer={assignContactModalFooter}
          headerClassName="custom_modal_header"
          className="custom_modal_dialog modal_dialog_sm assign_contact_modal"
          onHide={() => {
            if (!showAssignContactModal) return;
            setShowAssignContactModal(false);
          }}
          dismissableMask
        >
          <div className="custom_modal_body fixed_height" ref={contactListBodyRef}>
            <div className="pt-0 px-sm-0 px-1 pb-2 w-100">
              <div className="share_contact_tab_header">
                <div className="contact_tabs">
                  <div className="contact_tab_item">
                    <button
                      type="button"
                      className={`contact_tab_btn ${userType === null ? "active" : ""} p-ripple`}
                      onClick={() => handleSelectUserType(null)}
                    >
                      {`All: ${String(countAll).padStart(2, '0')}`}
                      <Ripple pt={{ root: { style: { background: "rgba(164, 96, 253, 0.2)" } } }} />
                    </button>
                  </div>

                  <div className="contact_tab_item">
                    <button
                      type="button"
                      className={`contact_tab_btn ${userType === "Employee" ? "active" : ""} p-ripple`}
                      onClick={() => handleSelectUserType("Employee")}
                    >
                      {`Employee: ${String(countEmployee).padStart(2, '0')}`}
                      <Ripple pt={{ root: { style: { background: "rgba(164, 96, 253, 0.2)" } } }} />
                    </button>
                  </div>

                  <div className="contact_tab_item">
                    <button
                      type="button"
                      className={`contact_tab_btn ${userType === "Professional" ? "active" : ""} p-ripple`}
                      onClick={() => handleSelectUserType("Professional")}
                    >
                      {`Professional: ${String(countProfessional).padStart(2, '0')}`}
                      <Ripple pt={{ root: { style: { background: "rgba(164, 96, 253, 0.2)" } } }} />
                    </button>
                  </div>

                  <div className="contact_tab_item">
                    <button
                      type="button"
                      className={`contact_tab_btn ${userType === "Client" ? "active" : ""} p-ripple`}
                      onClick={() => handleSelectUserType("Client")}
                    >
                      {`Client: ${String(countClient).padStart(2, '0')}`}
                      <Ripple pt={{ root: { style: { background: "rgba(164, 96, 253, 0.2)" } } }} />
                    </button>
                  </div>
                </div>

                <div className="data_search_input_area contact_search">
                  <InputText
                    key={"contactSearchKey"}
                    id="contactSearchKey"
                    value={searchKey}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                      handleContactSearchKey(e.target.value)
                    }
                    className="custom_form_input data_search_input"
                    placeholder="Search contact by name"
                    autoComplete="off"
                    autoFocus
                    type={"search"}
                  />
                  {searchKey === "" ? (
                    <i className="bi bi-search"></i>
                  ) : (
                    <i
                      className="bi bi-x-lg data_search_input_clear"
                      onClick={() => handleContactSearchKey('')}
                    ></i>
                  )}
                </div>
              </div>

              {/* <div className="data_view_filter_area">
                <div className="row">
                  <div className="col-12 col-xl-6 col-lg-6 col-sm-6 ms-auto me-0">
                    <div className="page_form_group mb-3 mb-sm-4">
                      <Dropdown value={userType} id="userType" onChange={handleSelectUserType}
                        options={userTypes} valueTemplate={selectedUserTypeTemplate} itemTemplate={userTypeOptionTemplate}
                        placeholder="Select user type" className="form_dropdown w-100" showClear />
                    </div>
                  </div>

                  <div className="col-12 col-xl-6 col-lg-6 col-sm-6 ms-0 me-auto">
                    <div className="page_form_group mb-4">
                      <Dropdown value={role} id="role" onChange={handleSelectUserRole}
                        options={userRoles} optionLabel="role_name" valueTemplate={selectedRoleTemplate} itemTemplate={roleOptionTemplate}
                        placeholder="Select role" className="form_dropdown w-100" showClear />
                    </div>
                  </div>
                </div>
              </div> */}

              <div className="row">
                {projectContactsFiltered?.length > 0 ? (
                  <div className="col-12">
                    <ul className="assign_contact_list_area mt-sm-2 ps-sm-4 pe-sm-4 mb-sm-3 mb-2">
                      {projectContactsFiltered.map((contact) => (
                        <li className="assign_contact_list w-100">
                          <Checkbox
                            onChange={(e) => handleCheckForAssignContact(contact)}
                            checked={contact.icChecked}
                          ></Checkbox>

                          <button
                            className={`contact_slide_tab assign_contact p-ripple ${contact.icChecked && "active"}`}
                            onClick={(e) => handleCheckForAssignContact(contact)}
                          >
                            <Image
                              className="contact_profile_img"
                              src={contact?.profile_image}
                              alt="Profile"
                            />
                            <div className="contact_slide_det">
                              <h6>
                                {contact?.first_name + " " + contact?.last_name}
                              </h6>

                              {contact.role_name && (
                                <p>{contact.role_name}</p>
                              )}

                              {contact?.email && (
                                <small>
                                  {contact?.email}
                                </small>
                              )}
                            </div>
                            <Ripple pt={{ root: { style: { background: "rgba(164, 96, 253, 0.2)" } } }} />
                          </button>
                        </li>
                      ))}
                    </ul>
                  </div>
                ) : (
                  <div className="col-12">
                    <div className="no_data_found d-flex align-content-center flex-column justify-content-center mt-2 mb-2"
                      style={{ height: bodyHeight }}>
                      <h6>
                        {searchKey
                          ? `No contact(s) found matching "${searchKey}".`
                          : (userType === "All" || projectContacts?.length === 0)
                            ? "No contacts have been created yet. Go to Contacts to create, then assign contacts to the project."
                            : `No ${userType?.toLowerCase()} contact(s) found!`}
                      </h6>

                      {projectContacts?.length === 0 && (
                        <button
                          className={`add_data_btn p-ripple mt-3 mx-auto`}
                          onClick={() => navigate('/contact')}
                        >
                          <i className={`bi bi-box-arrow-up-left`}></i>
                          Contacts
                          <Ripple />
                        </button>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </Dialog>
        {/* ************************************************************************************************ */}


        {/* ********************************* View Assigned Employee modal ********************************* */}
        <Dialog
          visible={showViewAssignContactModal}
          header={viewAssignContactModalHeader}
          headerClassName="custom_modal_header"
          className="custom_modal_dialog modal_dialog_lg"
          onHide={() => {
            if (!showViewAssignContactModal) return;
            setShowViewAssignContactModal(false);
          }}
          contentClassName="custom_modal_dialog_content"
          dismissableMask
        >
          <div className="custom_modal_body">
            <div className="p-1 p-sm-3 pt-sm-2 pb-sm-0 w-100">
              <div className="row">
                <div className="page_breadcrumb_area">
                  <ul className="page_breadcrumb">
                    <li className="page_breadcrumb_item active">
                      {selectedProject?.job_number + ": " + selectedProject?.address}
                    </li>
                  </ul>

                  {isPermissionAddContactShortcut && (
                    <button
                      className="add_data_link_btn p-ripple"
                      onClick={assignContact}
                    >
                      <i className="bi bi-plus-circle"></i>
                      <span>Assign contact</span>
                      <Ripple />
                    </button>
                  )}
                </div>

                <div className="view_assign_contact_area">
                  <div className="row">
                    <div className="col-12 col-xl-4">
                      <div className="view_assign_contact_list_area">
                        {selectedProject?.contact.map((contact) => (
                          <button className={`contact_slide_tab assign_contact select p-ripple ${contact.id === selectedProjectBasicContact?.id ? "active" : ""}`}
                            onClick={() => handleViewContact(contact)}
                          >
                            <Image
                              className="contact_profile_img"
                              src={contact?.profile_image}
                              alt="Profile"
                            />
                            <div className="contact_slide_det">
                              <h6>{contact.first_name}</h6>
                              {<p>{contact.last_name}</p>}
                            </div>
                            <Ripple pt={{ root: { style: { background: "rgba(164, 96, 253, 0.2)" } } }} />
                          </button>
                        ))}
                      </div>
                    </div>
                    <div className="col-12 col-xl-8 mt-3 mt-xl-0">
                      <article className="contact_view_container pos_sticky">
                        {selectedProjectBasicContact && (
                          <div className="row">
                            <div className="col-11 col-xl-9 col-xxl-8 col-lg-9 col-md-9 col-sm-10 mx-auto">
                              <div className="contact_view_head_area">
                                <Image
                                  className="profile_img_area"
                                  src={selectedProjectBasicContact?.profile_image}
                                  alt="Profile"
                                  preview
                                />
                                <h5 className="profile_name">
                                  {selectedProjectBasicContact.first_name}
                                </h5>
                                <h6 className="profile_role">
                                  {selectedProjectBasicContact.role_name}
                                </h6>
                              </div>

                              <hr className="mt-3 mb-3 mt-sm-4 mb-sm-4" />

                              <div className="row">
                                {getNonNullValue(selectedProjectBasicContact.address) &&
                                  getNonNullValue(selectedProjectBasicContact.post_code) &&
                                  getNonNullValue(selectedProjectBasicContact.city) && (
                                    <div className="col-12">
                                      <div className="contact_view_item">
                                        <i className="bi bi-geo-alt"></i>
                                        <p>
                                          {getNonNullValue(selectedProjectBasicContact.address)}{" "}
                                          <br />
                                          {getNonNullValue(selectedProjectBasicContact.post_code)}{" "}
                                          , &nbsp;
                                          {getNonNullValue(selectedProjectBasicContact.city)}{" "}
                                          <br />
                                        </p>
                                      </div>
                                    </div>
                                  )}

                                {getNonNullValue(selectedProjectBasicContact.mobile) && (
                                  <div className="col-12 col-sm-6">
                                    <div className="contact_view_item">
                                      <i className="bi bi-phone"></i>
                                      <Link to={`tel:${getNonNullValue(selectedProjectBasicContact.mobile)}`}>
                                        {getNonNullValue(selectedProjectBasicContact.mobile)}
                                      </Link>
                                    </div>
                                  </div>
                                )}

                                {getNonNullValue(selectedProjectBasicContact.landline) && (
                                  <div className="col-12 col-sm-6">
                                    <div className="contact_view_item">
                                      <i className="bi bi-telephone"></i>
                                      <Link to={`tel:${getNonNullValue(selectedProjectBasicContact.landline)}`}>
                                        {getNonNullValue(selectedProjectBasicContact.landline)}
                                      </Link>
                                    </div>
                                  </div>
                                )}

                                {getNonNullValue(selectedProjectBasicContact.email) && (
                                  <div className="col-12">
                                    <div className="contact_view_item">
                                      <i className="bi bi-envelope"></i>
                                      <Link to={`mailto:${getNonNullValue(selectedProjectBasicContact.email)}`}>
                                        {getNonNullValue(selectedProjectBasicContact.email)}
                                      </Link>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                      </article>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Dialog>
        {/* ************************************************************************************************ */}
      </div>

      {/* Renew project license */}
      <Dialog
        visible={showProjectRenewalModal}
        header={projectRenewalModalHeader}
        footer={projectRenewalModalFooter}
        headerClassName="custom_modal_header"
        className="custom_modal_dialog modal_dialog_sm"
        onHide={handleCloseProjectRenewalModal}
        dismissableMask
      >
        <div className="custom_modal_body">
          <div className="p-1 pt-2 p-sm-4 pt-sm-2 pb-sm-2 w-100">
            {selectedProject && selectedProject !== null && (
              <div className="row">
                {selectedProject?.subscription_id === freeSubscriptionPlan?.subscription_id ? (
                  <React.Fragment>
                    <div className="col-12">
                      <div className="page_form_group mb-4">
                        <Message
                          severity='warn'
                          className="message_text"
                          icon="bi bi-exclamation-circle"
                          style={{ border: '1px solid', borderRadius: '8px' }}
                          text={`Your current subscription plan is free, you cannot renew with the free plan, but you can purchase a new plan or use a different license. The plans and their pricing details are shown below.`}
                        />
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="page_form_group">
                        <label className="custom_form_label mb-1">
                          Choose subscription plan
                        </label>

                        {validSubscriptionPlansData && validSubscriptionPlansData?.length > 0 ? (
                          <div className="subscription_plans_swiper_area">
                            <Swiper
                              className='subscription_plans_swiper'
                              modules={[Navigation]}
                              spaceBetween={10}
                              slidesPerView={1}
                              loop={false}
                              navigation={{
                                nextEl: '.next_tab_btn',
                                prevEl: '.prev_tab_btn',
                              }}
                              grabCursor={true}
                              onSwiper={(swiper: SwiperType) => {
                                swiperRef.current = swiper
                              }}
                              onSlideChange={(swiper: SwiperType) => {
                                const activeIndex = swiper.activeIndex
                                const activePlan = validSubscriptionPlansData[activeIndex]
                                setSelectedSubscriptionPlan(activePlan)
                              }}
                            >
                              {validSubscriptionPlansData?.map((plan) => (
                                <SwiperSlide key={plan?.subscription_id}>
                                  <article
                                    className={`payment_summary_area clickable p-ripple ${plan?.subscription_id === selectedSubscriptionPlan?.subscription_id ? "selected" : "unselected"}`}
                                    onClick={() => handleSelectSubscriptionPlan(plan)}
                                  >
                                    <Tooltip
                                      key={`subs_info${plan.subscription_id}`}
                                      id={`subs_info${plan.subscription_id}`}
                                      target={`.subs_info${plan.subscription_id}`}
                                    />

                                    <div className="payment_summary_info">
                                      <h6>Subscription</h6>
                                      <p>{plan?.subscription_name} (01)
                                        <i className={`bi bi-info-circle ms-1 cursor_info subs_info${plan.subscription_id}`}
                                          data-pr-tooltip="For this project only."
                                          data-pr-position="top"
                                        ></i>
                                      </p>
                                    </div>

                                    <div className="payment_summary_info">
                                      <h6>Amount</h6>
                                      <p>
                                        {currencySymbol}&nbsp;
                                        {plan?.monthly_subscription_amount?.toFixed(1)}
                                      </p>
                                    </div>

                                    <div className="payment_summary_info">
                                      <h6>
                                        Tax ({plan?.tax_percentage?.toFixed(1)}%)
                                      </h6>
                                      <p>
                                        {currencySymbol}&nbsp;
                                        {(plan?.monthly_subscription_amount! * (plan?.tax_percentage! / 100))?.toFixed(1)}
                                      </p>
                                    </div>

                                    <div className="payment_summary_info">
                                      <h6>Subtotal</h6>
                                      <p>
                                        {currencySymbol}&nbsp;
                                        {(plan?.monthly_subscription_amount! + plan?.monthly_subscription_amount! * (plan?.tax_percentage! / 100))?.toFixed(1)}
                                      </p>
                                    </div>

                                    <div className="payment_summary_info mb-0">
                                      <h6>Features</h6>

                                      <button className={`add_data_btn p-ripple`}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleViewPlanFeatures();
                                        }}>
                                        <i className={`bi bi-eye-fill`}></i>
                                        See features
                                        < Ripple />
                                      </button>
                                    </div>
                                    <Ripple />
                                  </article>
                                </SwiperSlide>
                              ))}
                            </Swiper>

                            <button className="plan_tab_slide_btn is_btn prev_tab_btn p-ripple">
                              <i className="bi bi-chevron-left"></i>
                              <Ripple />
                            </button>

                            <button className="plan_tab_slide_btn is_btn next_tab_btn p-ripple">
                              <i className="bi bi-chevron-right"></i>
                              <Ripple />
                            </button>
                          </div>
                        ) : (
                          <div className="no_records_found" style={{ minHeight: "15vh" }}>
                            <i className="bi bi-exclamation-circle me-1"></i>
                            No subscription plans available.
                          </div>
                        )}

                        {validSubscriptionPlansData && validSubscriptionPlansData?.length > 0 && (
                          <button
                            className={`add_data_btn p-ripple mt-1`}
                            onClick={handleChangeLicence}
                          >
                            <i className={`bi bi-check2-circle`}></i>
                            Use another license
                            <Ripple />
                          </button>
                        )}
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="page_form_group mb-2">
                        <label className="custom_form_label mb-1">
                          Payment with
                        </label>

                        {loadingPaymentMethods ? (
                          <div className="payment_option_area">
                            <Skeleton className="payment_option_loading">
                              <Skeleton className="logo" />
                              <Skeleton className="label" />
                            </Skeleton>
                          </div>
                        ) : (
                          <React.Fragment>
                            {paymentMethodsData && paymentMethodsData?.length > 0 ? (
                              <div className="payment_option_area">
                                {paymentMethodsData?.map((paymentMethod) => (
                                  <button
                                    key={paymentMethod?.id}
                                    className="payment_option p-ripple"
                                    onClick={() => handlePurchasePayWith(paymentMethod)}
                                    disabled={selectedSubscriptionPlan === null}
                                  >
                                    <div className="payment_option_info">
                                      <Image
                                        src={paymentMethod?.logo}
                                        alt={paymentMethod?.type}
                                      />
                                      <p>{paymentMethod?.type}</p>
                                    </div>

                                    <i className="bi bi-chevron-right"></i>
                                    <Ripple />
                                  </button>
                                ))}
                              </div>
                            ) : (
                              <div className="no_records_found" style={{ minHeight: "15vh" }}>
                                <i className="bi bi-exclamation-circle me-1"></i>
                                No payment option(s) found.
                              </div>
                            )}
                          </React.Fragment>
                        )}
                      </div>
                    </div>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <div className="col-12">
                      <div className="page_form_group mb-3">
                        <label htmlFor="paymentSummary" className="custom_form_label mb-1">
                          Payment Summary (For one month)
                        </label>
                        {selectedProjectSubscription && selectedProjectSubscription !== null ? (
                          <article className="payment_summary_area" id="paymentSummary">
                            <div className="payment_summary_info">
                              <h6>Subscription</h6>
                              <p className="text_purple">{selectedProjectSubscription?.subscription_name}</p>
                            </div>

                            <div className="payment_summary_info">
                              <h6>Amount</h6>
                              <p>
                                {currencySymbol}&nbsp;
                                {(selectedProjectSubscription?.monthly_subscription_amount!).toFixed(1)}
                              </p>
                            </div>

                            <div className="payment_summary_info">
                              <h6>Tax ({selectedProjectSubscription?.tax_percentage?.toFixed(1)}%)</h6>
                              <p>
                                {currencySymbol}&nbsp;
                                {(selectedProjectSubscription?.monthly_subscription_amount! * selectedProjectSubscription?.tax_percentage! / 100)?.toFixed(1)}
                              </p>
                            </div>

                            <div className="payment_summary_info">
                              <h6>Total</h6>
                              <p>
                                {currencySymbol}&nbsp;
                                {(selectedProjectSubscription?.monthly_subscription_amount! + selectedProjectSubscription?.monthly_subscription_amount! * (selectedProjectSubscription?.tax_percentage! / 100))?.toFixed(1)}
                              </p>
                            </div>
                          </article>
                        ) : (
                          <div className="no_records_found" style={{ minHeight: "15vh" }}>
                            <i className="bi bi-exclamation-circle me-1"></i>
                            No detail found.
                          </div>
                        )}
                        <button
                          className={`add_data_btn p-ripple mt-1`}
                          onClick={handleChangeLicence}
                        >
                          <i className={`bi bi-check2-circle`}></i>
                          Use another license
                          <Ripple />
                        </button>
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="page_form_group mb-2">
                        <label htmlFor="paymentOption" className="custom_form_label mb-1">
                          Payment with
                        </label>

                        {loadingPaymentMethods ? (
                          <div className="payment_option_area">
                            <Skeleton className="payment_option_loading">
                              <Skeleton className="logo" />
                              <Skeleton className="label" />
                            </Skeleton>
                          </div>
                        ) : (
                          <React.Fragment>
                            {paymentMethodsData && paymentMethodsData?.length > 0 ? (
                              <div className="payment_option_area" id="paymentOption">
                                {paymentMethodsData?.map((paymentMethod) => (
                                  <button
                                    key={paymentMethod?.id}
                                    className="payment_option p-ripple"
                                    onClick={() => handleRenewalPayWith(paymentMethod)}
                                    disabled={selectedProjectSubscription === null}
                                  >
                                    <div className="payment_option_info">
                                      <Image
                                        src={paymentMethod?.logo}
                                        alt={paymentMethod?.type}
                                      />
                                      <p>{paymentMethod?.type}</p>
                                    </div>

                                    <i className="bi bi-chevron-right"></i>
                                    <Ripple />
                                  </button>
                                ))}
                              </div>
                            ) : (
                              <div className="no_records_found" style={{ minHeight: "15vh" }}>
                                <i className="bi bi-exclamation-circle me-1"></i>
                                No payment option(s) found.
                              </div>
                            )}
                          </React.Fragment>
                        )}
                      </div>
                    </div>
                  </React.Fragment>
                )}
              </div>
            )}
          </div>
        </div>
      </Dialog>
      {/*  */}


      {/* Plan feature modal */}
      <Dialog
        visible={showPlanFeatureModal}
        headerClassName="d-none"
        className="custom_modal_dialog modal_dialog_xsm"
        onHide={handleClosePlanFeatureModal}
        dismissableMask
        contentClassName="pb-3"
      >
        <div className="custom_modal_body">
          <button className="custom_modal_close position-absolute float p-ripple"
            onClick={handleClosePlanFeatureModal}>
            <i className="bi bi-x-lg"></i>
            <Ripple />
          </button>
          <div className="p-0 w-100">
            <div className="payment_form_area_header">
              <h6>Features</h6>
            </div>
            <div className="row">
              <div className="col-12">
                {selectedSubscriptionPlan && selectedSubscriptionPlan !== null ? (
                  <article className="plan_feature_card p-3">
                    <h4 className="plan_feature_head text-center mb-0" style={{ fontSize: "16px" }}>
                      {selectedSubscriptionPlan.subscription_name}
                    </h4>

                    <div className="plan_features_area mt-4">
                      <ul className="plan_card_feature_list">
                        {selectedSubscriptionPlan?.feature?.map(feature => (
                          <li>
                            <span style={{ fontSize: "14px" }} className="text-capitalize">
                              {feature.feature_name}
                            </span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </article>
                ) : (
                  <div className="no_records_found" style={{ minHeight: "25vh" }}>
                    <i className="bi bi-exclamation-circle me-1"></i>
                    No data found!.
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </Dialog>
      {/*  */}


      {/* Show success message */}
      <div
        className={`message_backdrop ${showAlert ? "show" : ""}`}
        onClick={handleCloseAlert}
      >
        <div
          className={`message_box ${showAlert ? "show" : ""}`}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="message_box_content">
            <i className="bi bi-check-circle-fill message_box_icon"></i>
            <h6 className="message_box_message">{successMessage}</h6>
          </div>
        </div>
      </div>
      {/*  */}


      {/* Folder move modal */}
      <Dialog
        visible={showFolderMoveModal}
        headerClassName="d-none"
        dismissableMask
        className="custom_modal_dialog modal_dialog_sm data_select_modal"
        contentClassName="data_select_modal_content"
        onHide={handleCloseFolderMoveModal}
      >
        <div className="custom_modal_body data_select_modal_area">
          <div className="data_select_modal_header">
            <div className="data_search_input_area">
              <InputText
                key={"projectSearchkey"}
                id="projectSearchkey"
                value={projectSearchkey}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setProjectSearchkey(e.target.value)}
                className="custom_form_input data_search_input"
                placeholder="Search project by address or job number"
                autoComplete="off"
                autoFocus
                type={"search"}
              />
              {projectSearchkey === "" ? (
                <i className="bi bi-search"></i>
              ) : (
                <i className="bi bi-x-lg data_search_input_clear" onClick={() => setProjectSearchkey("")}></i>
              )}
            </div>

            <button
              type="button"
              className="data_select_modal_close p-ripple"
              onClick={handleCloseFolderMoveModal}
            >
              <i className="bi bi-x"></i>
              <Ripple />
            </button>
          </div>

          <div className="data_select_modal_body has_custom_input">
            <div className="mb-3">
              <Message
                severity='warn'
                className="message_text w-100"
                icon="bi bi-exclamation-circle"
                style={{ border: '1px solid', borderRadius: '8px' }}
                text={`Note: When you move a folder or folders to a project, if the project license expires, you will not be able to access the folder in the project, you will only be able to access the folder after that project license is renewed.`}
              />
            </div>

            {filteredProjectsData && filteredProjectsData?.length > 0 ? (
              <div className="data_select_option_area">
                {filteredProjectsData?.map((project) => (
                  <React.Fragment>
                    <Tooltip
                      id={`project_inactive_${project?.project_id}`}
                      key={`project_inactive_${project?.project_id}`}
                      target={`.project_inactive_${project?.project_id}`}
                    />

                    <div
                      key={project?.project_id}
                      className={`data_select_option p-ripple ${project?.project_id === selectedProjectData?.project_id ? "selected" : ''}
                                  ${project?.this_project_active === 0 ? 'inactive' : ''}`}
                      onClick={() => handleSelectProject(project)}
                    >
                      {project?.job_number + " : " + project?.address + " " + project?.post_code}
                      <Ripple pt={{ root: { style: { background: "rgba(164, 96, 253, 0.2)" } } }} />

                      {project?.this_project_active === 0 && (
                        <i className={`bi bi-exclamation-circle warn_symbol project_inactive_${project?.project_id}`}
                          data-pr-tooltip="This project license has expired."
                          data-pr-position="left"
                        ></i>
                      )}
                    </div>
                  </React.Fragment>
                ))}
              </div>
            ) : (
              <div className="no_records_found">
                <i className="bi bi-exclamation-circle me-1"></i>
                No project(s) found.
              </div>
            )}
          </div>

          <div className="page_form_group data_select_modal_footer custom mb-0">
            <div>
              <h6>
                Move {selectedSharedFolders?.length} folder{selectedSharedFolders?.length > 1 ? "s" : ""}:&nbsp;<br />
                <small>To: <span>{selectedProjectData ? `${selectedProjectData?.job_number}: ${selectedProjectData?.address}` : '----'}</span></small>
              </h6>
            </div>

            <Button
              loading={moveFolderLoading}
              label={
                moveFolderLoading
                  ? "Processing"
                  : `Move folder${selectedSharedFolders?.length > 1 ? "s" : ""
                  } (${selectedSharedFolders?.length})`
              }
              className="custom_btn primary"
              onClick={handleMoveFolder}
              disabled={selectedProjectData === null}
            />
          </div>
        </div>
      </Dialog>
      {/*  */}


      {/* Expiration reminder modal */}
      <Dialog
        visible={showReminderModal}
        header={reminderModalHeader}
        footer={reminderModalFooter}
        headerClassName="custom_modal_header"
        className="custom_modal_dialog modal_dialog_sm"
        contentClassName="custom_modal_dialog_content"
        dismissableMask
        onHide={handleCloseReminderModal}
      >
        <div className="custom_modal_body">
          <div className="p-1 w-100">
            {selectedProject && selectedProject !== null && (
              <h6 className="info_text">
                <i className="bi bi-exclamation-circle me-2"></i>
                {selectedProject?.remaider_day_count === 0 ? (
                  <React.Fragment>
                    Your project expires <span className="text-danger">today</span>.
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    your project has expired within&nbsp;
                    <span className="text-danger">
                      {selectedProject?.remaider_day_count} day{selectedProject?.remaider_day_count! > 1 && 's'}
                    </span>.
                  </React.Fragment>
                )}

                <br />
                Please renew your project.
              </h6>
            )}
          </div>
        </div>
      </Dialog>


      <InfoModal
        show={showInfoModal}
        onClose={handleCloseInfoModal}
        title="Stay Tuned!"
        info={infoMessage}
        showAppLink={false}
      />

      {/* For renewal */}
      <CheckoutForm
        isOpen={showRenewalCheckoutForm}
        onClose={() => setShowRenewalCheckoutForm(false)}
        // getPaymentId={()=>getPaymentId(null)}
        onPaymentSuccess={handleRenewalPaymentSuccess}
        amount={renewalPaidTotal * 100}
      />
      {/*  */}


      {/* For purchase new subscription */}
      <CheckoutForm
        isOpen={showPurchaseCheckoutForm}
        onClose={() => setShowPurchaseCheckoutForm(false)}
        onPaymentSuccess={handlePurchasePaymentSuccess}
        amount={purchasePaidTotal * 100}
      />
      {/*  */}

    </React.Fragment >
  );
};

export default ProjectComponent;
